'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

//EwSiteApp.requires.push('flow');
//EwSiteApp.requires.push('ui.bootstrap');

function getJsCookieValue(a) {
	var b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
	return b ? b.pop() : '';
}

//function modalRejectHandler(result){
//	console.log(result);
//}

//EwSiteApp.config(['flowFactoryProvider', function (flowFactoryProvider) {
//		flowFactoryProvider.defaults = {
//			target: '',
//			permanentErrors: [202, 404, 500, 501],
//			maxChunkRetries: 1,
//			chunkRetryInterval: 5000,
//			simultaneousUploads: 1,
//			singleFile: false,
//			chunkSize: 2 * 1024 * 1024,
//			forceChunkSize: true
//		};
//		// Add XSRF header to upload requests
//		if (typeof (secure_xsrf_name) != 'undefined') {
//			var xsrf_token = getJsCookieValue(secure_xsrf_name);
//			if (xsrf_token !== '') {
//				flowFactoryProvider.defaults.headers = {};
//				flowFactoryProvider.defaults.headers['X-' + secure_xsrf_name] = xsrf_token;
//			}
//		}
//		flowFactoryProvider.on('fileSuccess', function (file, response) {
//			try {
//				eval("var d = " + response);
//				if (typeof (d.success) !== 'undefined') {
//					file.response = d;
//				}
//			} catch (err) {
//				console.error('Network Error: bad response format - ' + err.message);
//			}
//		});
//	}]);
//
//EwSiteApp.controller('MultiUpload', function ($scope, $filter, $log, $attrs) {
//	$scope.uploaded_files = [];
//	$scope.errors = [];
//	$scope.hasError = false;
//	$scope.closeAlert = function (index) {
//		$scope.errors.splice(index, 1);
//	};
//
//	$scope.transmitToParent = function () {
//		$scope.$parent.uploads_count += 1;
//	};
//
//	$scope.onFileAdded = function ($file, extensions) {
//		var output = false;
//		if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
//			output = true;
//		}
//		if (!output) {
//			$scope.hasError = true;
//			$scope.errors.push($file.name + ' ' + $attrs.errorMsg);
//		}
//		return output;
//	};
//
//	function flowErrors($file) {
//		if (typeof ($file.response) !== 'undefined') {
//			if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
//				return true;
//			} else if (typeof ($file.response.message) !== 'undefined') {
//				$scope.hasError = true;
//				$scope.errors.push($file.name + ' - ' + $file.response.message);
//				return false;
//			}
//		} else {
//			$scope.hasError = true;
//			$scope.errors.push($file.name + ' - Server error');
//			return false;
//		}
//		return null;
//	}
//
//	$scope.onFileSuccess = function ($file, $message, flowFile) {
//		let flow_errors = flowErrors($file);
//		if (true === flow_errors) {
//			$scope.transmitToParent();
//		} else if (false === flow_errors) {
//			flowFile.cancel();
//		}
//	};
//
//	$scope.onFileError = function ($file, $message, flowFile) {
//		if (false === flowErrors($file)) {
//			flowFile.cancel();
//		}
//	};
//
//	$scope.removeufile = function (ufile) {
//		$scope.uploaded_files = $filter('filter')($scope.uploaded_files, {id: '!' + ufile.id}, true);
//		if ($scope.$parent.uploads_count > 0) {
//			$scope.$parent.uploads_count -= 1;
//		}
//	};
//
//
//	$scope.removeUploaded = function (file) {
//		file.cancel();
//		if ($scope.$parent.uploads_count > 0) {
//			$scope.$parent.uploads_count -= 1;
//		}
//	};
//});

EwSiteApp.controller('HelpdeskFormCtrl',['$scope', '$http', '$filter', '$uibModal', '$log', '$sce', '$interval', '$timeout', 'SessionService', 'localStorageService', function ($scope, $http, $filter, $uibModal, $log, $sce, $interval, $timeout, SessionService, localStorageService) {
	$scope.form_id = 0;
	$scope.uploads_count = 0;
//	$scope.sum_kw_invalid = false;
	$scope.contractor_cert_nr_prefix = 'E-';
	$scope.form8_contractor_cert_nr_prefix = 'EI-';
	$scope.eek_atvado_tipas = 'vienfazis';
	$scope.sistema_veikia_salos_rezime = '2';
	$scope.contractor_cert_nr = '';
	$scope.form;
	$scope.formPeta;
	$scope.submitted = false;
	$scope.displayStatus = 0;
	$scope.navigation = jsHelpdesk.navigation;
	$scope.nrCheckUrl = jsHelpdesk.nrCheckUrl;
	$scope.dokobitSignUrl = jsHelpdesk.dokobit_sign_url;
	$scope.dataUrl = jsHelpdesk.data_url;
	$scope.situation_title = [];
	$scope.check_obj_contract_nr = '';
	$scope.checking_nr = false;
	$scope.check_data = [];
	$scope.dokobit_state = 0;
	$scope.refreshInterval = 8000;
	$scope.token = '';
	$scope.iframe_height = '1000px';
	$scope.signing_origin = jsHelpdesk.signing_origin;
	$scope.vertCheckUrl = jsHelpdesk.vertCheckUrl;
	$scope.prijungiami_irenginiai = jsHelpdesk.prijungiami_irenginiai;
	$scope.istekliu_rusis = jsHelpdesk.istekliu_rusis;
	$scope.chemines_sudetys = jsHelpdesk.chemines_sudetys;
	$scope.vertNrValid = false;
	$scope.vert_document_nr = '';
	$scope.vert_application_term_nr = '';
	$scope.n63 = false;
	$scope.storedParams = {};
	$scope.storeParams = true;
	$scope.uploaded_files = [];
	$scope.file_url = '';
	$scope.signed_files = {};
	$scope.hasSignedFiles = function() { return Object.keys($scope.signed_files).length > 0; };

	$scope.form_8_fields = {
		form_id: 8,
		require_signed_file: false,
		contractor_address: '',
		contractor_address_municipality: '',
		contractor_address_city: '',
		contractor_address_street: '',
		contractor_house: '',
		contractor_appartment: '',
		contractor_housing: '',
		obj_address: '',
		obj_address_municipality: '',
		obj_address_city: '',
		obj_address_street: '',
		obj_house: '',
		obj_appartment: '',
		obj_housing: '',
		nutolusi_elektrine: false,
		obj_gas_kiekis: ''
	};
//		$scope.displayStatus = 6;
//		$scope.form_id = 1;

	var interval;

	$scope.$watch("contractor_phone", function (newVal) {
		if (newVal) {
			$scope.fullPhone = '+370' + newVal;
		} else {
			$scope.fullPhone = '';
		}
	});
	$scope.$watch("form_8_fields.contractor_phone", function (newVal) {
		if (newVal) {
			$scope.fullPhonePeta = '+370' + newVal;
		} else {
			$scope.fullPhonePeta = '';
		}
	});
	$scope.$watch("vert_rangovo_atstovo_tel", function (newVal) {
		if (newVal) {
			$scope.fullPhone2 = '+370' + newVal;
				console.log(newVal);
		} else {
			$scope.fullPhone2 = '';
		}
	});

	$scope.checkVertNr = function () {
		$scope.checking_nr = true;
		if ($scope.vertCheckUrl !== '') {
			$scope.vertNrValid = false;
			$http({
				method: 'POST',
				url: $scope.vertCheckUrl,
				data: {
					vert_application_term_nr: $scope.vert_application_term_nr,
					vert_document_nr: $scope.vert_document_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.vertNrValid = true;
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
			;
		}
	};

	$scope.form6Invalid = function () {
		return (!$scope.vert_application_term_nr || !$scope.vert_document_nr);
	};

	function dokobitSign() {
		$scope.errors = '';
		$scope.show_loader = true;
		$scope.recaptchaResponse = '';
		$scope.dokobitFileId = '';
		$scope.iframe_height = '1000px';
		$scope.dokobit_state = 0;
		$scope.file_url = '';
		if ($scope.dokobitSignUrl !== '') {
			let postData = {
					fields: {
						contractor_name: $scope.contractor_name,
						contractor_address: $scope.contractor_address,
						contractor_address_id: $scope.contractor_address_id,
						contractor_address_municipality: $scope.contractor_address_municipality,
						contractor_address_city: $scope.contractor_address_city,
						contractor_address_street: $scope.contractor_address_street,
						contractor_phone: $scope.contractor_phone,
						contractor_email: $scope.contractor_email,
						contractor_cert_date: $scope.contractor_cert_date,
						contractor_cert_nr: $scope.contractor_cert_nr_full,
						contractor_cert_nr_prefix: $scope.contractor_cert_nr_prefix,
						contractor_insurance_date: $scope.contractor_insurance_date,
						contractor_insurance_date_to: $scope.contractor_insurance_date_to,
						contractor_insurance_nr: $scope.contractor_insurance_nr,
						contractor_house: $scope.contractor_house,
						contractor_appartment: $scope.contractor_appartment,
						contractor_housing: $scope.contractor_housing,
						act_date: $scope.act_date,
						obj_name: $scope.obj_name,
						obj_address: $scope.obj_address,
						obj_address_id: $scope.obj_address_id,
						obj_address_municipality: $scope.obj_address_municipality,
						obj_address_city: $scope.obj_address_city,
						obj_address_street: $scope.obj_address_street,
						obj_owner: $scope.obj_owner,
						obj_owner_email: $scope.obj_owner_email,
						obj_contract_date: $scope.obj_contract_date,
						obj_contract_nr: $scope.obj_contract_nr,
						obj_total_power: $scope.obj_total_power,
						obj_work_supervisor_title: $scope.obj_work_supervisor_title,
						obj_work_supervisor_nr: $scope.obj_work_supervisor_nr,
						obj_work_supervisor_nr_company: $scope.obj_work_supervisor_nr_company,
						contractor_insurer: $scope.contractor_insurer,
						status: $scope.status,
						agree_to_terms: $scope.agree_to_terms,
						agree_to_terms_time: $scope.agree_to_terms_time,
//						contractor_house: $scope.contractor_house,
//						contractor_housing: $scope.contractor_housing,
//						contractor_appartment: $scope.contractor_appartment,
						obj_house: $scope.obj_house,
						obj_housing: $scope.obj_housing,
						obj_appartment: $scope.obj_appartment,
						form_id: $scope.form_id,
						obj_new_installed_power: $scope.obj_new_installed_power,
						frequency: $scope.frequency,
						notes: $scope.notes,
						leistina_generuoti_galia: $scope.leistina_generuoti_galia,
						naujai_irengiama_elektrines_galia: $scope.naujai_irengiama_elektrines_galia,
						keitikliu_kiekis_objekte: $scope.keitikliu_kiekis_objekte,
						keitiklio_nominali_galia: $scope.keitiklio_nominali_galia,
						keitiklio_nominali_galia_2: $scope.keitiklio_nominali_galia_2,
						keitiklio_nominali_galia_3: $scope.keitiklio_nominali_galia_3,
						keitiklio_nominali_galia_4: $scope.keitiklio_nominali_galia_4,
						keitiklio_nominali_galia_5: $scope.keitiklio_nominali_galia_5,
						keitiklio_nominali_galia_6: $scope.keitiklio_nominali_galia_6,
						per_zema_itampa_u: $scope.per_zema_itampa_u,
						per_aukstas_daznis_f_maziau_10_kw_laikas: $scope.per_aukstas_daznis_f_maziau_10_kw_laikas,
						per_aukstas_daznis_f_daugiau_10_k_w_daznis: $scope.per_aukstas_daznis_f_daugiau_10_k_w_daznis,
						per_aukstas_daznis_f_dagiau_10_kw_laikas: $scope.per_aukstas_daznis_f_dagiau_10_kw_laikas,
						per_zemas_daznis_1_f_daznis: $scope.per_zemas_daznis_1_f_daznis,
						per_zemas_daznis_1_f_laikas: $scope.per_zemas_daznis_1_f_laikas,
						per_zemas_daznis_2_f_daznis: $scope.per_zemas_daznis_2_f_daznis,
						apsauga_nuo_daznio_kitimo_spartos: $scope.apsauga_nuo_daznio_kitimo_spartos,
						automatinis_prisijungimas_po_daznio_atsistatymo: $scope.automatinis_prisijungimas_po_daznio_atsistatymo,
//						saules_modulio_galia: $scope.saules_modulio_galia,
//						saules_moduliu_kiekis: $scope.saules_moduliu_kiekis,
//						saules_modulio_galia_2: $scope.saules_modulio_galia_2,
//						saules_moduliu_kiekis_2: $scope.saules_moduliu_kiekis_2,
//						saules_modulio_galia_3: $scope.saules_modulio_galia_3,
//						saules_moduliu_kiekis_3: $scope.saules_moduliu_kiekis_3,
						//moduliu_galiu_kiekis: $scope.moduliu_galiu_kiekis,
						keitikliu_tipas: $scope.keitikliu_tipas,
						moduliu_tipas: $scope.moduliu_tipas,
						per_auksta_itampa_uuv: $scope.per_auksta_itampa_uuv,
						elektrines_tipas: $scope.elektrines_tipas,
						chemine_sudetis: $scope.chemine_sudetis,
						energijos_kaupimo_irenginio_talpa: $scope.energijos_kaupimo_irenginio_talpa,
						eek_atvado_tipas: $scope.eek_atvado_tipas,
						sistema_veikia_salos_rezime: $scope.sistema_veikia_salos_rezime,
						rangovo_v_pavarde: $scope.rangovo_v_pavarde,
						energijos_kaupimo_irenginiu_kiekis: $scope.energijos_kaupimo_irenginiu_kiekis,
						kaupiklio_galia_kw: $scope.kaupiklio_galia_kw,
						irengtu_irenginiu_sumine_galia: $scope.irengtu_irenginiu_sumine_galia,
						n20: $scope.n20,
						n21: $scope.n21,
						n22: $scope.n22,
						n23: $scope.n23,
						n24: $scope.n24,
						n25: $scope.n25,
						n26: $scope.n26,
						n27: $scope.n27,
						n28: $scope.n28,
						n29: $scope.n29,
						n30: $scope.n30,
						n31: $scope.n31,
						n32: $scope.n32,
						n33: $scope.n33,
						n34: $scope.n34,
						n35: $scope.n35,
						n36: $scope.n36,
						n37: $scope.n37,
						n38: $scope.n38,
						n39: $scope.n39,
						n40: $scope.n40,
						n41: $scope.n41,
						n42: $scope.n42,
						n43: $scope.n43,
						n44: $scope.n44,
						n45: $scope.n45,
						n46: $scope.n46,
						n47: $scope.n47,
						n48: $scope.n48,
						n49: $scope.n49,
						n50: $scope.n50,
						n51: $scope.n51,
						n52: $scope.n52,
						n53: $scope.n53,
						n54: $scope.n54,
						n55: $scope.n55,
						n56: $scope.n56,
						n57: $scope.n57,
						n58: $scope.n58,
						n59: $scope.n59,
						n60: $scope.n60,
						n61: $scope.n61,
						n62: $scope.n62,
						n63: $scope.n63,
						n64: $scope.n64,
						n65: $scope.n65,
						n66: $scope.n66,
						n67: $scope.n67,
						n68: $scope.n68,
						n69: $scope.n69,
						n70: $scope.n70,
						n71: $scope.n71,
						n72: $scope.n72,
						n73: $scope.n73,
						n74: $scope.n74,
						n75: $scope.n75,
						n76: $scope.n76,
						n77: $scope.n77,
						n78: $scope.n78,
						n79: $scope.n79,
						n80: $scope.n80,
						n81: $scope.n81,
						energijos_kaupimo_irenginys: $scope.energijos_kaupimo_irenginys,
						per_auksta_itampa_1u_itampa_uv: $scope.per_auksta_itampa_1u_itampa_uv,
						per_auksta_itampa_1u_laikas_ts: $scope.per_auksta_itampa_1u_laikas_ts,
						per_aukstas_daznis_1f_daznis_fhz: $scope.per_aukstas_daznis_1f_daznis_fhz,
						taskas_1_uun: $scope.taskas_1_uun,
						taskas_2_uun: $scope.taskas_2_uun,
						taskas_3_uun: $scope.taskas_3_uun,
						taskas_4_uun: $scope.taskas_4_uun,
						per_aukstas_daznis_2_f_daznis_fhz: $scope.per_aukstas_daznis_2_f_daznis_fhz,
						gas_apskaitu_kiekis: $scope.gas_apskaitu_kiekis,
						n22_talpa: $scope.n22_talpa,
						n22_chem: $scope.n22_chem,
						n22_brand: $scope.n22_brand,
						n25_talpa: $scope.n25_talpa,
						n25_chem: $scope.n25_chem,
						n25_brand: $scope.n25_brand,
						n28_talpa: $scope.n28_talpa,
						n28_chem: $scope.n28_chem,
						n28_brand: $scope.n28_brand,
						n37_irenginys: $scope.n37_irenginys,
						n38_irenginys: $scope.n38_irenginys,
						n39_irenginys: $scope.n39_irenginys,
						n40_irenginys: $scope.n40_irenginys,
						n41_irenginys: $scope.n41_irenginys,
						n42_irenginys: $scope.n42_irenginys,
						apskaitu_skaicius: $scope.apskaitu_skaicius
					},
					files: $scope.uploaded_files
				};
				if (typeof jsHelpdesk.recaptcha !== 'undefined') {
					grecaptcha.ready(function () {
						grecaptcha.execute(jsHelpdesk.recaptcha.siteKey, {action: 'submit'}).then(function (token) {
							postData[jsHelpdesk.recaptcha.field] = token;
							$http({
								method: 'POST',
								url: $scope.dokobitSignUrl,
								data: postData,
								xsrfCookieName: secure_xsrf_name,
								xsrfHeaderName: 'X-' + secure_xsrf_name
							}).then(function (response) {
								if (!response.data.success && response.data.reload_page) {
									window.location.reload();
								}
								if (response.data.success) {
									$scope.show_loader = false;
									$scope.iframe_src = $sce.trustAsResourceUrl(response.data.iframe_src);
									$scope.token = response.data.token;
									$scope.storeFormParamsToLs();
									$scope.refreshList();
								} else if (angular.isDefined(response.data.message)) {
									$scope.errors = response.data.message;
								} else {
									$scope.errors = jsHelpdesk.server_blocked_text;
								}
								if (angular.isDefined(response.data.debug)) {
									$log.debug(response.data.debug);
								}
							}).then(function () {
								$scope.show_loader = false;

							});
						});
					});
				} else {
					$scope.errors = jsHelpdesk.server_blocked_text;
				}

		}
	};

	function dokobitSignForm8() {
		$scope.errors = '';
		$scope.show_loader = true;
		$scope.iframe_src = '';
		$scope.dokobitFileId = '';
		$scope.iframe_height = '1000px';
		$scope.dokobit_state = 0;
		$scope.file_url = '';
		if ($scope.dokobitSignUrl !== '') {
			let postData = {
				fields: angular.copy($scope.form_8_fields),
				files: $scope.uploaded_files,
				signed_files: $scope.signed_files
			};
			postData.fields.contractor_cert_nr = $scope.contractor_cert_nr_full;
			postData.fields.contractor_cert_nr_prefix = $scope.form8_contractor_cert_nr_prefix;
			if (typeof jsHelpdesk.recaptcha !== 'undefined') {
				grecaptcha.ready(function () {
					grecaptcha.execute(jsHelpdesk.recaptcha.siteKey, {action: 'submit'}).then(function (token) {
						postData[jsHelpdesk.recaptcha.field] = token;
						$http({
							method: 'POST',
							url: $scope.dokobitSignUrl,
							data: postData,
							xsrfCookieName: secure_xsrf_name,
							xsrfHeaderName: 'X-' + secure_xsrf_name
						}).then(function (response) {
							if (!response.data.success && response.data.reload_page) {
								window.location.reload();
							}
							if (response.data.success) {
								$scope.show_loader = false;
								$scope.iframe_src = $sce.trustAsResourceUrl(response.data.iframe_src);
								$scope.token = response.data.token;
								$scope.refreshList();
								$scope.storeFormParamsToLs();
							} else if (angular.isDefined(response.data.message)) {
								$scope.errors = response.data.message;
							} else {
								$scope.errors = jsHelpdesk.server_blocked_text;
							}
							if (angular.isDefined(response.data.debug)) {
								$log.debug(response.data.debug);
							}
						}).then(function () {
							$scope.show_loader = false;

						});
					});
				});
			} else {
				$scope.errors = jsHelpdesk.server_blocked_text;
			}

		}
	};

	$scope.showSign = function () {
		return (parseInt($scope.form_id) === 1 || parseInt($scope.form_id) === 2 || parseInt($scope.form_id) === 5 || parseInt($scope.displayStatus) === 84);
	};

	$scope.showSignForm8 = function () {
		return (parseInt($scope.form_id) === 8 && parseInt($scope.displayStatus) === 805);
	};

	$scope.gotoSign = function (e) {
		e.preventDefault();
		if($scope.form_id==7){
			$scope.displayStatus = 85;
		}
		else{
			$scope.displayStatus = 4;
		}
		$scope.situation_title.push(jsHelpdesk.dokobit_sign_text);
		document.querySelector('.index_container').scrollIntoView({
			behavior: 'smooth'
		});
		dokobitSign();
	};

	$scope.gotoSignForm8 = function (e) {
		e.preventDefault();
		if(!$scope.form_id==8){
			return;
		}
		var template = 'helpdesk/form_8_modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'HelpdeskForm8ConfirmCtrl',
			//size: 'sm',
			resolve: {
				item: function () {
					return $scope.form_8_fields;
				}
			}
		});
		modalInstance.result.then(function(result){
			if(result.state==1){
				// Comment this line for PDF download test
				$scope.displayStatus = 85;
				$scope.situation_title.push(jsHelpdesk.dokobit_sign_text);
				document.querySelector('.index_container').scrollIntoView({
					behavior: 'smooth'
				});
				dokobitSignForm8();
			}
			else if(result.state==2){
				$scope.goBackToDisplayStatus(803);
			}
		}, function(result){
			console.log(result);
		});


	};

	$scope.loadData = function () {
		if ($scope.dataUrl !== '') {
			$http({
				method: 'GET',
				url: $scope.dataUrl,
				params: {
					token: $scope.token
				}

			}).then(function (response) {
				$scope.dokobit_state = response.data.state;
				$scope.iframe_src = $sce.trustAsResourceUrl(response.data.iframe_src);
				if($scope.dokobit_state>2){
					$interval.cancel(interval);
				}
				if ($scope.dokobit_state === 3) {
					$scope.dokobitFileId = response.data.file_id;
					$scope.file_url = response.data.file_url;
					$scope.uploaded_files = [];
					$scope.signed_files = {};
					$scope.uploads_count = 0;
					$scope.$broadcast('cancelFiles');
				}
				if($scope.dokobit_state===4){
					window.location.reload();
				}
			});

		}
	};

//	$scope.loadData();

	$scope.refreshList = function () {
		interval = $interval(function () {
			$scope.loadData();
		}, $scope.refreshInterval);
	};
//	$scope.refreshList();

	$scope.formInvalid = function () {
		if (!$scope.kwValid() || !$scope.leistinaGeneruotiGaliaValid() || !$scope.saulesModulioGaliaValid() || !$scope.objnewinstalledpowerValid() || !$scope.perZemaItampaUValid() || !$scope.perAukstasDaznisfMaziau10kwLaikasValid() || !$scope.perAukstasDaznisfDaugiau10kwDaznisValid() || !$scope.perAukstasDaznisfDaugiau10kwLaikasValid() || !$scope.perZemasDaznis1fDaznisValid() || !$scope.perZemasDaznis1fLaikasValid() || !$scope.perZemasDaznis2fDaznisValid() || !$scope.apsaugaNuoDaznioKitimoSpartosValid() || !$scope.automatinisPrisijungimasPoDaznioAtsistatymoValid() || !$scope.frequencyValid() || !$scope.contractorDateValid() || !$scope.bandymuTerminasValid() || !$scope.perAukstaItampaUUVValid() || !$scope.actDateValid() || !$scope.perAukstaItampa1UItampaUVValid() || !$scope.perAukstaItampa1ULaikasTSValid() || !$scope.perAukstasDaznis1fDaznisFhzValid() || !$scope.perAukstasDaznis2fDaznisFhz() || !$scope.contractNrValid()) {
			return true;
		}
		if ($scope.form_id == '') {
			return true;
		}
		if ($scope.form_id == 4) {
			if ($scope.uploads_count < 1) {
				return true;
			}
		}
		if (($scope.form_id == 1 || $scope.form_id == 2) && parseInt($scope.apskaitu_skaicius) > 1 && $scope.uploads_count < 1) {
			return true;
		}
		if ($scope.submitted) {
			return true;
		}
	};

	$scope.contractNrValid = function () {
//		if (parseInt($scope.form_id) === 1 || parseInt($scope.form_id) === 2 || parseInt($scope.form_id) === 5 || parseInt($scope.form_id) === 7) {
//			const pattern1 = /^\d{5}-\d{2}-.+$/;     // XXXXX-XX-Y, where X is any digit and Y can be any character(s)
//			const pattern2 = /^\d{2}-KA\d{7}$/;      // XX-KAXXXXXXX, where X is any digit
//			const pattern3 = /^\d{2}-RA\d{5}$/;      // XX-RAXXXXX, where X is any digit
//			const pattern4 = /^\d{2}-[0-9A-Za-z]\d{4}$/; // XX-YXXXX, where X is any digit, and Y is any digit or letter
//
//			const combinedPattern = new RegExp(
//					pattern1.source + '|' +
//					pattern2.source + '|' +
//					pattern3.source + '|' +
//					pattern4.source
//			);
//			return combinedPattern.test($scope.obj_contract_nr);
//		}
		return true;
	};

	$scope.kwValid = function () {

//		if (parseInt($scope.form_id) === 3) {
//			if (typeof ($scope.obj_total_power) !== 'undefined' && typeof ($scope.obj_new_installed_power) !== 'undefined') {
//				if (parseFloat($scope.obj_total_power) >= parseFloat($scope.obj_new_installed_power)) {
//					return true;
//				}
//			}
//			return false;
//		}
		return true;
	};

	$scope.leistinaGeneruotiGaliaValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if(parseInt($scope.form_id) === 3 && $scope.nutolusi_elektrine){
				return true;
			}
			if (typeof ($scope.leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.obj_total_power) !== 'undefined') {
					if (parseFloat($scope.leistina_generuoti_galia) > parseFloat($scope.obj_total_power)) {
						return false;
					}
				}
				if (typeof ($scope.obj_new_installed_power) !== 'undefined') {
					if (parseFloat($scope.leistina_generuoti_galia) > parseFloat($scope.obj_new_installed_power)) {
						return false;
					}
				}
				return true;
			}

			return false;
		}
		return true;
	};

	$scope.leistinaGeneruotiGaliaValid2 = function () {
		if (parseInt($scope.form_id) === 5) {

			if (typeof ($scope.leistina_generuoti_galia) !== 'undefined') {
				if(parseInt($scope.keitikliu_kiekis_objekte)===1){
					if (parseFloat($scope.leistina_generuoti_galia) > parseFloat($scope.keitiklio_nominali_galia)) {
						return false;
					}
				}
				if(parseInt($scope.keitikliu_kiekis_objekte)===2){
					if (parseFloat($scope.leistina_generuoti_galia) > (parseFloat($scope.keitiklio_nominali_galia)+parseFloat($scope.keitiklio_nominali_galia_2))) {
						return false;
					}
				}
				if(parseInt($scope.keitikliu_kiekis_objekte)===3){
					if (parseFloat($scope.leistina_generuoti_galia) > (parseFloat($scope.keitiklio_nominali_galia)+parseFloat($scope.keitiklio_nominali_galia_2)+parseFloat($scope.keitiklio_nominali_galia_3))) {
						return false;
					}
				}
				if(parseInt($scope.keitikliu_kiekis_objekte)===4){
					if (parseFloat($scope.leistina_generuoti_galia) > (parseFloat($scope.keitiklio_nominali_galia)+parseFloat($scope.keitiklio_nominali_galia_2)+parseFloat($scope.keitiklio_nominali_galia_3)+parseFloat($scope.keitiklio_nominali_galia_4))) {
						return false;
					}
				}
				if(parseInt($scope.keitikliu_kiekis_objekte)===5){
					if (parseFloat($scope.leistina_generuoti_galia) > (parseFloat($scope.keitiklio_nominali_galia)+parseFloat($scope.keitiklio_nominali_galia_2)+parseFloat($scope.keitiklio_nominali_galia_3)+parseFloat($scope.keitiklio_nominali_galia_4)+parseFloat($scope.keitiklio_nominali_galia_5))) {
						return false;
					}
				}
				if(parseInt($scope.keitikliu_kiekis_objekte)===6){
					if (parseFloat($scope.leistina_generuoti_galia) > (parseFloat($scope.keitiklio_nominali_galia)+parseFloat($scope.keitiklio_nominali_galia_2)+parseFloat($scope.keitiklio_nominali_galia_3)+parseFloat($scope.keitiklio_nominali_galia_4)+parseFloat($scope.keitiklio_nominali_galia_5)+parseFloat($scope.keitiklio_nominali_galia_6))) {
						return false;
					}
				}
				return true;
			}

			return false;
		}
		return true;
	};

	$scope.eekAtvadoTipasValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.leistina_generuoti_galia) !== 'undefined' && parseFloat($scope.leistina_generuoti_galia) > 3.6 && $scope.eek_atvado_tipas == 'vienfazis') {
				return false;
			}
		}
		return true;
	};

	$scope.contractorDateValid = function () {
		if ($scope.contractor_insurance_date > $scope.contractor_insurance_date_to) {
			return false;
		}
		return true;
	};

	$scope.actDateValid = function () {
		if (parseInt($scope.form_id) === 5 || parseInt($scope.form_id) === 7) {
			if ($scope.act_date > $scope.contractor_insurance_date_to || $scope.act_date < $scope.contractor_insurance_date) {
				return false;
			}
		}
		return true;
	};

	$scope.objnewinstalledpowerValid = function () {
		if (parseInt($scope.form_id) === 3) {
			if (typeof ($scope.obj_new_installed_power) !== 'undefined' && parseFloat($scope.obj_new_installed_power) > 100) {
				return false;
			}
		}
		return true;
	};

	$scope.saulesModulioGaliaValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.saules_modulio_galia) !== 'undefined' && parseFloat($scope.saules_modulio_galia) > 1000) {
				return false;
			}
		}
		return true;
	};

	$scope.perAukstaItampaUUVValid = function () {
		if (parseInt($scope.form_id) === 3) {
			if (typeof ($scope.per_auksta_itampa_uuv) !== 'undefined') {
				if (parseFloat($scope.per_auksta_itampa_uuv) === 255.3) {
					return true;
				}
				if (parseFloat($scope.per_auksta_itampa_uuv) === 253) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.perAukstaItampa1UItampaUVValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_auksta_itampa_1u_itampa_uv) !== 'undefined') {
				if (parseFloat($scope.per_auksta_itampa_1u_itampa_uv) === 255.3) {
					return true;
				}
				if (parseFloat($scope.per_auksta_itampa_1u_itampa_uv) === 253) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.perAukstaItampa1ULaikasTSValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if(typeof ($scope.per_auksta_itampa_1u_laikas_ts) !== 'undefined' && isNaN(parseFloat($scope.per_auksta_itampa_1u_laikas_ts))){
				return false;
			}
			if (typeof ($scope.per_auksta_itampa_1u_laikas_ts) !== 'undefined' && (parseFloat($scope.per_auksta_itampa_1u_laikas_ts) < 0 || parseFloat($scope.per_auksta_itampa_1u_laikas_ts) > 600)) {
				return false;
			}
		}
		return true;
	};

	$scope.perAukstasDaznis1fDaznisFhzValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_aukstas_daznis_1f_daznis_fhz) !== 'undefined' && (parseFloat($scope.per_aukstas_daznis_1f_daznis_fhz) < 50.2 || parseFloat($scope.per_aukstas_daznis_1f_daznis_fhz) > 50.5)) {
				return false;
			}
		}
		return true;
	};

	$scope.perAukstasDaznis2fDaznisFhz = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_aukstas_daznis_2_f_daznis_fhz) !== 'undefined' && (parseFloat($scope.per_aukstas_daznis_2_f_daznis_fhz) < 51.5)) {
				return false;
			}
		}
		return true;
	};

	$scope.perZemaItampaUValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_zema_itampa_u) !== 'undefined' && (parseFloat($scope.per_zema_itampa_u) < 0 || parseFloat($scope.per_zema_itampa_u) > 600)) {
				return false;
			}
		}
		return true;
	};

	$scope.paramIn100Scope = function (param) {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope[param]) !== 'undefined' && isNaN(parseFloat($scope[param]))){
				return false;
			}
			if (typeof ($scope[param]) !== 'undefined' && (parseFloat($scope[param]) < 0 || parseFloat($scope[param]) > 100)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramIn600Scope = function (param) {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope[param]) !== 'undefined' && isNaN(parseFloat($scope[param]))){
				return false;
			}
			if (typeof ($scope[param]) !== 'undefined' && (parseFloat($scope[param]) < 0 || parseFloat($scope[param]) > 600)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN33Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n33) !== 'undefined' && isNaN(parseFloat($scope.n33))){
				return false;
			}
			if (!$scope.nutolusi_elektrine && parseFloat($scope.n33) > parseFloat($scope.n31)) {
				return false;
			}
			if ((parseFloat($scope.n33) > parseFloat($scope.n32))) {
				return false;
			}
			if (typeof ($scope.n33) !== 'undefined' && (parseFloat($scope.n33) < 0 || parseFloat($scope.n33) > 100)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN33ValidSum = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n33) !== 'undefined' && isNaN(parseFloat($scope.n33))){
				return false;
			}
				if(parseInt($scope.n36)===1){
					if (parseFloat($scope.n33) > parseFloat($scope.n37)) {
						return false;
					}
				}
				if(parseInt($scope.n36)===2){
					if (parseFloat($scope.n33) > (parseFloat($scope.n37)+parseFloat($scope.n38))) {
						return false;
					}
				}
				if(parseInt($scope.n36)===3){
					if (parseFloat($scope.n33) > (parseFloat($scope.n37)+parseFloat($scope.n38)+parseFloat($scope.n39))) {
						return false;
					}
				}
				if(parseInt($scope.n36)===4){
					if (parseFloat($scope.n33) > (parseFloat($scope.n37)+parseFloat($scope.n38)+parseFloat($scope.n39)+parseFloat($scope.n40))) {
						return false;
					}
				}
				if(parseInt($scope.n36)===5){
					if (parseFloat($scope.n33) > (parseFloat($scope.n37)+parseFloat($scope.n38)+parseFloat($scope.n39)+parseFloat($scope.n40)+parseFloat($scope.n41))) {
						return false;
					}
				}
				if(parseInt($scope.n36)===6){
					if (parseFloat($scope.n33) > (parseFloat($scope.n37)+parseFloat($scope.n38)+parseFloat($scope.n39)+parseFloat($scope.n40)+parseFloat($scope.n41)+parseFloat($scope.n42))) {
						return false;
					}
				}
				return true;
			}
		return true;
	};

	$scope.paramN31Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n31) !== 'undefined' && isNaN(parseFloat($scope.n31))){
				return false;
			}

			if (typeof ($scope.n31) !== 'undefined' && parseFloat($scope.n31) < 0) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN34Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n34) !== 'undefined' && isNaN(parseFloat($scope.n34))){
				return false;
			}
			if (parseFloat($scope.n34) > parseFloat($scope.n32)) {
				return false;
			}
			if (typeof ($scope.n34) !== 'undefined' && (parseFloat($scope.n34) < 0 || parseFloat($scope.n34) > 100)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN44Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n44) !== 'undefined') {
				if (parseFloat($scope.n44) === 255.3) {
					return true;
				}
				if (parseFloat($scope.n44) === 253) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN46Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n46) !== 'undefined') {
				if (parseFloat($scope.n46) === 264.5) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN47Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n47) !== 'undefined') {
				if (parseFloat($scope.n47) === 0.2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN48Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n48) !== 'undefined') {
				if (parseFloat($scope.n48) === 193.2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN49Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n49) !== 'undefined' && isNaN(parseFloat($scope.n49))){
				return false;
			}
			if (typeof ($scope.n49) !== 'undefined' && (parseFloat($scope.n49) < 0 || parseFloat($scope.n49) > 600)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN50Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n50) !== 'undefined') {
				if (parseFloat($scope.n50) === 184) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN51Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n51) !== 'undefined') {
				if (parseFloat($scope.n51) === 2.9) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN52Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n52) !== 'undefined' && isNaN(parseFloat($scope.n52))){
				return false;
			}
			if (typeof ($scope.n52) !== 'undefined' && (parseFloat($scope.n52) < 51 || parseFloat($scope.n52) > 51.49)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN53Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n53) !== 'undefined' && isNaN(parseFloat($scope.n53))){
				return false;
			}
			if (typeof ($scope.n53) !== 'undefined' && parseFloat($scope.n53) < 1800) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN54Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n54) !== 'undefined' && isNaN(parseFloat($scope.n54))){
				return false;
			}
			if (typeof ($scope.n54) !== 'undefined' && (parseFloat($scope.n54) < 50.2 || parseFloat($scope.n54) > 50.5)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN55Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n55) !== 'undefined' && isNaN(parseFloat($scope.n55))){
				return false;
			}
			if (typeof ($scope.n55) !== 'undefined' && (parseFloat($scope.n55) < 0 || parseFloat($scope.n55) > 100)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN56Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n56) !== 'undefined' && isNaN(parseFloat($scope.n56))){
				return false;
			}
			if (typeof ($scope.n56) !== 'undefined' && (parseFloat($scope.n56) < 47.5 || parseFloat($scope.n56) > 49)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN57Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n57) !== 'undefined' && isNaN(parseFloat($scope.n57))){
				return false;
			}
			if (typeof ($scope.n57) !== 'undefined' && parseFloat($scope.n57) < 1800) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN58Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n58) !== 'undefined' && isNaN(parseFloat($scope.n58))){
				return false;
			}
			if (typeof ($scope.n58) !== 'undefined' && parseFloat($scope.n58) > 47.49) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN59Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n59) !== 'undefined') {
				if (parseFloat($scope.n59) === 0.2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN60Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n60) !== 'undefined') {
				$scope.n60 = $scope.n60.replace(/,/, '.');
				if ($scope.n60.toLowerCase() === 'nepalaikoma') {
					return true;
				}
			}
			if (typeof ($scope.n60) !== 'undefined' && parseFloat($scope.n60) >= 2.5) {
				return true;
			}
		}
		return false;
	};
	$scope.paramN61Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n61) !== 'undefined' && isNaN(parseFloat($scope.n61))){
				return false;
			}
			if (typeof ($scope.n61) !== 'undefined' && parseFloat($scope.n61) > 10) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN62Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n62) !== 'undefined') {
				if (parseFloat($scope.n62) === 50.2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN64Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n64) !== 'undefined' && isNaN(parseFloat($scope.n64))){
				return false;
			}
			if (typeof ($scope.n64) !== 'undefined' && (parseFloat($scope.n64) < 0.91 || parseFloat($scope.n64) > 0.92)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN65Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n65) !== 'undefined') {
				if (parseFloat($scope.n65) === 0.484) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN66Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n66) !== 'undefined' && isNaN(parseFloat($scope.n66))){
				return false;
			}
			if (typeof ($scope.n66) !== 'undefined' && (parseFloat($scope.n66) < 0.95 || parseFloat($scope.n66) > 0.96)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN67Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n67) !== 'undefined') {
				if (parseFloat($scope.n67) === 0) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN68Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n68) !== 'undefined' && isNaN(parseFloat($scope.n68))){
				return false;
			}
			if (typeof ($scope.n68) !== 'undefined' && (parseFloat($scope.n68) < 1.04 || parseFloat($scope.n68) > 1.05)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN69Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n69) !== 'undefined') {
				if (parseFloat($scope.n69) === 0) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN70Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if(typeof ($scope.n70) !== 'undefined' && isNaN(parseFloat($scope.n70))){
				return false;
			}
			if (typeof ($scope.n70) !== 'undefined' && (parseFloat($scope.n70) < 1.08 || parseFloat($scope.n70) > 1.09)) {
				return false;
			}
		}
		return true;
	};
	$scope.paramN71Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n71) !== 'undefined') {
				if (parseFloat($scope.n71) === -0.484) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN72Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n72) !== 'undefined') {
				if (parseFloat($scope.n72) === 0.05) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN73Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n73) !== 'undefined') {
				if (parseFloat($scope.n73) === 0.25) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN74Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n74) !== 'undefined') {
				if (parseFloat($scope.n74) === 0.15) {
					return true;
				}
				if (parseFloat($scope.n74) === 0.7) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN75Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n75) !== 'undefined') {
				if (parseFloat($scope.n75) === 0.25) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN76Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n76) !== 'undefined') {
				if (parseFloat($scope.n76) === 0.15) {
					return true;
				}
				if (parseFloat($scope.n76) === 0.7) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN77Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n77) !== 'undefined') {
				if (parseFloat($scope.n77) === 0.25) {
					return true;
				}
				if (parseFloat($scope.n77) === 0.7) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN78Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n78) !== 'undefined') {
				if (parseFloat($scope.n78) === 0.85) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN79Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n79) !== 'undefined') {
				if (parseFloat($scope.n79) === 1.5) {
					return true;
				}
				if (parseFloat($scope.n79) === 3) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN80Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n80) !== 'undefined') {
				if (parseFloat($scope.n80) === 2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};
	$scope.paramN81Valid = function () {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope.n81) !== 'undefined') {
				if (parseFloat($scope.n81) === 2) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.elKeitiklioItampaXValid = function (param) {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope[param]) !== 'undefined') {
				if (parseFloat($scope[param]) === 0.23) {
					return true;
				}
				if (parseFloat($scope[param]) === 0.4) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.elKeitiklioItampaXValid2 = function (param) {
		if (parseInt($scope.form_id) === 7) {
			if (typeof ($scope[param]) !== 'undefined' && parseFloat($scope[param]) === 0.23 && typeof ($scope.n33) !== 'undefined' && parseFloat($scope.n33) > 3.6) {
				return false;
			}
		}
		return true;
	};



	$scope.form5Page1Valid = function () {
		if(!$scope.leistinaGeneruotiGaliaValid() || !$scope.leistinaGeneruotiGaliaValid2() || !$scope.eekAtvadoTipasValid() || !$scope.saulesModulioGaliaValid() || !$scope.objnewinstalledpowerValid() || !$scope.perZemaItampaUValid() || !$scope.perAukstasDaznisfMaziau10kwLaikasValid() || !$scope.perAukstasDaznisfDaugiau10kwDaznisValid() || !$scope.perAukstasDaznisfDaugiau10kwLaikasValid() || !$scope.perZemasDaznis1fDaznisValid() || !$scope.perZemasDaznis1fLaikasValid() || !$scope.perZemasDaznis2fDaznisValid() || !$scope.apsaugaNuoDaznioKitimoSpartosValid() || !$scope.automatinisPrisijungimasPoDaznioAtsistatymoValid() || !$scope.frequencyValid() || !$scope.contractorDateValid() || !$scope.bandymuTerminasValid() || !$scope.perAukstaItampaUUVValid() || !$scope.actDateValid() || !$scope.perAukstaItampa1UItampaUVValid() || !$scope.perAukstaItampa1ULaikasTSValid() || !$scope.perAukstasDaznis1fDaznisFhzValid() || !$scope.perAukstasDaznis2fDaznisFhz()
		){
			return false;
		}
		return true;
	};

	$scope.form5Page2Valid = function () {
		if(!$scope.paramTaskas1UunValid() || !$scope.paramTaskas2UunValid() || !$scope.paramTaskas3UunValid() || !$scope.paramTaskas4UunValid()
		){
			return false;
		}
		return true;
	};

	$scope.paramTaskas1UunValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.taskas_1_uun) !== 'undefined') {
				if (parseFloat($scope.taskas_1_uun) === 0.91) {
					return true;
				}
				if (parseFloat($scope.taskas_1_uun) === 0.92) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.paramTaskas2UunValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.taskas_2_uun) !== 'undefined') {
				if (parseFloat($scope.taskas_2_uun) === 0.95) {
					return true;
				}
				if (parseFloat($scope.taskas_2_uun) === 0.96) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.paramTaskas3UunValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.taskas_3_uun) !== 'undefined') {
				if (parseFloat($scope.taskas_3_uun) === 1.05) {
					return true;
				}
				if (parseFloat($scope.taskas_3_uun) === 1.04) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.paramTaskas4UunValid = function () {
		if (parseInt($scope.form_id) === 5) {
			if (typeof ($scope.taskas_4_uun) !== 'undefined') {
				if (parseFloat($scope.taskas_4_uun) === 1.09) {
					return true;
				}
				if (parseFloat($scope.taskas_4_uun) === 1.08) {
					return true;
				}
				return false;
			}
		}
		return true;
	};

	$scope.form7Page1Valid = function () {
		if(!$scope.paramN44Valid() || !$scope.paramIn600Scope('45') ||
				!$scope.paramN46Valid() || !$scope.paramN47Valid() ||
				!$scope.paramN48Valid() || !$scope.paramN49Valid() ||
				!$scope.paramN50Valid() || !$scope.paramN51Valid() ||
				!$scope.paramN52Valid() || !$scope.paramN53Valid() ||
				(parseFloat($scope.n32)<=10 && (!$scope.paramN54Valid() || !$scope.paramN55Valid())) ||
				!$scope.paramN56Valid() || !$scope.paramN57Valid() ||
				!$scope.paramN58Valid() || !$scope.paramN59Valid() ||
				!$scope.paramN60Valid() || !$scope.paramN61Valid() ||
				!$scope.paramN62Valid()
		){
			return false;
		}
		if($scope.elektrines_tipas === 'hybrid' && (!$scope.paramIn100Scope('n20') || !$scope.paramIn100Scope('n21') || !$scope.paramIn100Scope('n23') || !$scope.paramIn100Scope('n24') || !$scope.paramIn100Scope('n26') || !$scope.paramIn100Scope('n27'))){
			return false;
		}
		if(!$scope.paramN31Valid() || !$scope.paramIn100Scope('n32') || !$scope.paramN33Valid() || !$scope.paramN33ValidSum() || !$scope.paramN34Valid()){
			return false;
		}
		if(($scope.n36>0 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n37_itampa') || !$scope.elKeitiklioItampaXValid2('n37_itampa'))){
			return false;
		}
		if(($scope.n36>1 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n38_itampa') || !$scope.elKeitiklioItampaXValid2('n38_itampa'))){
			return false;
		}
		if(($scope.n36>2 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n39_itampa') || !$scope.elKeitiklioItampaXValid2('n39_itampa'))){
			return false;
		}
		if(($scope.n36>3 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n40_itampa') || !$scope.elKeitiklioItampaXValid2('n40_itampa'))){
			return false;
		}
		if(($scope.n36>4 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n41_itampa') || !$scope.elKeitiklioItampaXValid2('n41_itampa'))){
			return false;
		}
		if(($scope.n36>5 && $scope.n36<7) && (!$scope.elKeitiklioItampaXValid('n42_itampa') || !$scope.elKeitiklioItampaXValid2('n42_itampa'))){
			return false;
		}
		return true;
	};

	$scope.form7Page2Valid = function () {
		if((!$scope.paramN64Valid() || !$scope.paramN65Valid() ||
				!$scope.paramN66Valid() || !$scope.paramN67Valid() ||
				!$scope.paramN68Valid() || !$scope.paramN69Valid() ||
				!$scope.paramN70Valid() || !$scope.paramN71Valid())
		){
			return false;
		}
		return true;
	};
	$scope.form7Page3Valid = function () {
		if(parseFloat($scope.n32)>=10 && (!$scope.paramN72Valid() || !$scope.paramN73Valid() ||
				!$scope.paramN74Valid() || !$scope.paramN75Valid() ||
				!$scope.paramN76Valid() || !$scope.paramN77Valid() ||
				!$scope.paramN78Valid() || !$scope.paramN79Valid() ||
				!$scope.paramN80Valid() || !$scope.paramN81Valid())
		){
			return false;
		}
		return true;
	};
	$scope.form7Page4Valid = function () {
		if(parseFloat($scope.n32)>=12 && (!$scope.paramN80Valid() || !$scope.paramN81Valid())){
			return false;
		}
		return true;
	};
	$scope.perAukstasDaznisfMaziau10kwLaikasValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_aukstas_daznis_f_maziau_10_kw_laikas) !== 'undefined' && (parseFloat($scope.per_aukstas_daznis_f_maziau_10_kw_laikas) < 0 || parseFloat($scope.per_aukstas_daznis_f_maziau_10_kw_laikas) > 1)) {
				return false;
			}
		}
		return true;
	};

	$scope.perAukstasDaznisfDaugiau10kwDaznisValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_aukstas_daznis_f_daugiau_10_k_w_daznis) !== 'undefined' && (parseFloat($scope.per_aukstas_daznis_f_daugiau_10_k_w_daznis) < 51.0 || parseFloat($scope.per_aukstas_daznis_f_daugiau_10_k_w_daznis) > 51.49)) {
				return false;
			}
		}
		return true;
	};

	$scope.perAukstasDaznisfDaugiau10kwLaikasValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_aukstas_daznis_f_dagiau_10_kw_laikas) !== 'undefined' && (parseFloat($scope.per_aukstas_daznis_f_dagiau_10_kw_laikas) < 1800 || parseFloat($scope.per_aukstas_daznis_f_dagiau_10_kw_laikas) > 10000)) {
				return false;
			}
		}
		return true;
	};

	$scope.perZemasDaznis1fDaznisValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_zemas_daznis_1_f_daznis) !== 'undefined' && (parseFloat($scope.per_zemas_daznis_1_f_daznis) < 47.5 || parseFloat($scope.per_zemas_daznis_1_f_daznis) > 49)) {
				return false;
			}
		}
		return true;
	};
	$scope.perZemasDaznis1fLaikasValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_zemas_daznis_1_f_laikas) !== 'undefined' && (parseFloat($scope.per_zemas_daznis_1_f_laikas) < 1800 || parseFloat($scope.per_zemas_daznis_1_f_laikas) > 10000)) {
				return false;
			}
		}
		return true;
	};

	$scope.perZemasDaznis2fDaznisValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.per_zemas_daznis_2_f_daznis) !== 'undefined' && (parseFloat($scope.per_zemas_daznis_2_f_daznis) < 0 || parseFloat($scope.per_zemas_daznis_2_f_daznis) > 47.49)) {
				return false;
			}
		}
		return true;
	};

	$scope.frequencyValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.frequency) !== 'undefined' && (parseFloat($scope.frequency) < 50.2 || parseFloat($scope.frequency) > 50.5)) {
				return false;
			}
		}
		return true;
	};

	$scope.apsaugaNuoDaznioKitimoSpartosValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.apsauga_nuo_daznio_kitimo_spartos) !== 'undefined') {
				const replaced = $scope.apsauga_nuo_daznio_kitimo_spartos.replace(/,/, '.');
				if ($scope.apsauga_nuo_daznio_kitimo_spartos.toLowerCase() === 'nepalaikoma') {
//					console.log($scope.apsauga_nuo_daznio_kitimo_spartos)
					return true;
				}
				if (parseFloat(replaced) >= 2.5 && parseFloat(replaced) <= 20) {
					return true;
				}
				return false;
			}
		}

		return true;
	};

	$scope.automatinisPrisijungimasPoDaznioAtsistatymoValid = function () {
		if (parseInt($scope.form_id) === 3 || parseInt($scope.form_id) === 5) {
			if (typeof ($scope.automatinis_prisijungimas_po_daznio_atsistatymo) !== 'undefined' && (parseFloat($scope.automatinis_prisijungimas_po_daznio_atsistatymo) < 1 || parseFloat($scope.automatinis_prisijungimas_po_daznio_atsistatymo) > 10)) {
				return false;
			}
		}
		return true;
	};

	$scope.bandymuTerminasValid = function () {
		if (parseInt($scope.form_id) === 4) {
			if (parseInt($scope.document_type) !== 3) {
				return true;
			}
			if ($scope.vert_term_tests_date < $scope.vert_document_date) {
				return false;
			}
		}
		return true;
	};

	$scope.$watch("contractor_cert_nr", function (newVal, oldVal) {
//		if(typeof newVal !== 'undefined'){
//		}
		$scope.updateContractorCertNr();
	});

	$scope.$watch("form_8_fields.contractor_cert_nr", function (newVal, oldVal) {
		$scope.contractor_cert_nr_full = $scope.form8_contractor_cert_nr_prefix + $scope.form_8_fields.contractor_cert_nr;
	});

	$scope.$watch("vert_application_term_nr", function (newVal, oldVal) {
		if (typeof newVal !== 'undefined') {
			newVal = newVal.replace(/[^0-9a-z]/ig, '').substring(0, 7).replace(/^(0[0-9]|10|11|12|13)/, '').replace(/^(.{2})(.+)$/i, '$1-$2');
			$scope.vert_application_term_nr = newVal;
		}
	});

	$scope.updateContractorCertNr = function () {
		$scope.contractor_cert_nr_full = $scope.contractor_cert_nr_prefix + $scope.contractor_cert_nr;
	};

	$scope.termsModal = function () {
		var template = 'helpdesk/modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'HelpdeskPreviewCtrl',
			//size: 'sm',
			resolve: {
				item: function () {
					//return true;
				}
			}
		});

//		modalInstance.result.then(function(result){
//
//		}, modalRejectHandler);
	};

	$scope.termsModalPeta = function () {
		var template = 'helpdesk/modal_peta.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'HelpdeskPreviewCtrl',
			//size: 'sm',
			resolve: {
				item: function () {
					//return true;
				}
			}
		});

//		modalInstance.result.then(function(result){
//
//		}, modalRejectHandler);
	};
//	$scope.updateFormId = function (form_id) {
//		$scope.form_id = form_id;
////		$scope.displayStatus = 5;
//		if ($scope.form_id == 2) {
//			$scope.contractor_cert_nr_prefix = 'E-';
//			$scope.updateContractorCertNr();
//		}
//		console.log($scope.form_id)
//		console.log($scope.displayStatus)
//	};

	$scope.formSubmit = function (e) {
		e.preventDefault();
		$scope.submitted = true;
		let formEl = $scope.form;
		if($scope.form_id===8){
			formEl = $scope.formPeta;
		}
		var captcha_element = '#g-recaptcha-response-hidden';

		$scope.storeFormParamsToLs();

		let is_grecaptcha = formEl.find(captcha_element).length > 0;
		if (is_grecaptcha && typeof (grecaptcha) !== 'undefined') {
			grecaptcha.ready(function () {
				grecaptcha.execute($(captcha_element).data('sitekey'), {action: 'submit'}).then(function (token) {
					let hiddenInput = formEl.find(captcha_element);
					if (hiddenInput.length) {
						hiddenInput.val(token);
					}
					else {
						var inp = document.createElement('input');
						inp.type = 'hidden';
						inp.name = 'g-recaptcha-response';
						inp.value = token;
						formEl[0].appendChild(inp);
					}
					formEl[0].submit();
				});
			});
		} else {
			formEl[0].submit();
		}
	};

	$scope.storeFormParamsToLs = function () {

		if($scope.storeParams){
			localStorageService.init(`helpdesk_forma_${$scope.form_id}`,{params:$scope.storedParams});
			switch ($scope.form_id) {
				case 1:
					$scope.storedParams = {
							contractor_name: $scope.contractor_name,
							contractor_address: $scope.contractor_address,
							contractor_address_id: $scope.contractor_address_id,
							contractor_address_municipality: $scope.contractor_address_municipality,
							contractor_address_city: $scope.contractor_address_city,
							contractor_address_street: $scope.contractor_address_street,
							contractor_phone: $scope.contractor_phone,
							contractor_email: $scope.contractor_email,
							contractor_cert_date: $scope.contractor_cert_date,
							contractor_cert_nr: $scope.contractor_cert_nr,
							contractor_cert_nr_prefix: $scope.contractor_cert_nr_prefix,
							contractor_cert_nr_full: $scope.contractor_cert_nr_full,
							contractor_insurance_date: $scope.contractor_insurance_date,
//							contractor_insurance_date_to: $scope.contractor_insurance_date_to,
							contractor_insurance_nr: $scope.contractor_insurance_nr,
							contractor_house: $scope.contractor_house,
							contractor_appartment: $scope.contractor_appartment,
							contractor_housing: $scope.contractor_housing,
							contractor_insurer: $scope.contractor_insurer,
							obj_work_supervisor_title: $scope.obj_work_supervisor_title,
							obj_work_supervisor_nr: $scope.obj_work_supervisor_nr,
							obj_work_supervisor_nr_company: $scope.obj_work_supervisor_nr_company
					};
					break;
				case 2:
					$scope.storedParams = {
							contractor_name: $scope.contractor_name,
							rangovo_v_pavarde: $scope.rangovo_v_pavarde,
							contractor_address: $scope.contractor_address,
							contractor_address_id: $scope.contractor_address_id,
							contractor_address_municipality: $scope.contractor_address_municipality,
							contractor_address_city: $scope.contractor_address_city,
							contractor_address_street: $scope.contractor_address_street,
							contractor_phone: $scope.contractor_phone,
							contractor_email: $scope.contractor_email,
							contractor_cert_date: $scope.contractor_cert_date,
							contractor_cert_nr: $scope.contractor_cert_nr,
							contractor_cert_nr_prefix: $scope.contractor_cert_nr_prefix,
							contractor_cert_nr_full: $scope.contractor_cert_nr_full

					};
					break;
				case 4:
					$scope.storedParams = {
							contractor_name: $scope.contractor_name,
							vert_rangovo_atstovo_email: $scope.vert_rangovo_atstovo_email,
							vert_rangovo_atstovo_tel: $scope.vert_rangovo_atstovo_tel

					};
					break;
				case 8:
					$scope.storedParams = {
							contractor_name: $scope.form_8_fields.contractor_name,
							contractor_address: $scope.form_8_fields.contractor_address,
							contractor_address_id: $scope.form_8_fields.contractor_address_id,
							contractor_address_municipality: $scope.form_8_fields.contractor_address_municipality,
							contractor_address_city: $scope.form_8_fields.contractor_address_city,
							contractor_address_street: $scope.form_8_fields.contractor_address_street,
							contractor_phone: $scope.form_8_fields.contractor_phone,
							contractor_email: $scope.form_8_fields.contractor_email,
							contractor_cert_date: $scope.form_8_fields.contractor_cert_date,
							contractor_cert_nr: $scope.form_8_fields.contractor_cert_nr,
							contractor_cert_nr_prefix: $scope.form_8_fields.contractor_cert_nr_prefix,
							contractor_cert_nr_full: $scope.form_8_fields.contractor_cert_nr_full,
							contractor_insurance_date: $scope.form_8_fields.contractor_insurance_date,
//							contractor_insurance_date_to: $scope.form_8_fields.contractor_insurance_date_to,
							contractor_insurance_nr: $scope.form_8_fields.contractor_insurance_nr,
							contractor_house: $scope.form_8_fields.contractor_house,
							contractor_appartment: $scope.form_8_fields.contractor_appartment,
							contractor_housing: $scope.form_8_fields.contractor_housing,
							obj_work_supervisor_title: $scope.form_8_fields.obj_work_supervisor_title,
							obj_work_supervisor_nr: $scope.form_8_fields.obj_work_supervisor_nr,
							obj_work_supervisor_nr_company: $scope.form_8_fields.obj_work_supervisor_nr_company,
							contractor_insurer: $scope.form_8_fields.contractor_insurer
					};
					break;
				default:
					break;
			}
			localStorageService.setData({params:$scope.storedParams});
		}
	};

	function receiveMessage(event) {
		if (event.origin.startsWith($scope.signing_origin)) {
			if (event.data.success == true) {
				$scope.iframe_height = '200px';
				$scope.dokobit_state = 2;
				$timeout(function () {
					$scope.$apply();
				});
			}
		} else {
			return;
		}
	}
	window.addEventListener("message", receiveMessage, false);

	$scope.checkInstalledPower = function () {
		if (typeof ($scope.obj_new_installed_power) === 'undefined') {
			return false;
		}
		const replaced = $scope.obj_new_installed_power.replace(/,/, '.');
		return replaced <= 10;
	};

	$scope.installedPowerGreater30 = function () {
		if (typeof ($scope.obj_new_installed_power) === 'undefined') {
			return false;
		}
		return parseFloat($scope.obj_new_installed_power) > 30;
	};

	$scope.n32Greater30 = function () {
		if (typeof ($scope.n32) === 'undefined') {
			return false;
		}
		return parseFloat($scope.n32) > 30;
	};

	$scope.n32GreaterEqual30 = function () {
		if (typeof ($scope.n32) === 'undefined') {
			return false;
		}
		return parseFloat($scope.n32) >= 30;
	};

	$scope.checkInstalledPowerGreater = function () {
		if (typeof ($scope.obj_new_installed_power) === 'undefined') {
			return false;
		}
		return parseFloat($scope.obj_new_installed_power) > 10;
	};

	$scope.setDisplayStatus = function (btn) {
		if (typeof (btn) !== 'object') {
			$scope.displayStatus = btn;
		} else {
			$scope.displayStatus = btn.question_id;
		}

		for (var i = 0, len = $scope.navigation.length; i < len; i++) {
			if ($scope.navigation[i].id == btn.question_id) {
				$scope.situation_title.push($scope.navigation[i].title);
				$scope.id = i;
				break;
			}
		}

		switch ($scope.displayStatus) {
			case 6:
				$scope.form_id = 1;
				$scope.resetContractorCertNr();
				$scope.storedParams = {
					contractor_name: '',
					contractor_address: '',
					contractor_address_id: '',
					contractor_address_municipality: '',
					contractor_address_city: '',
					contractor_address_street: '',
					contractor_phone: '',
					contractor_email: '',
					contractor_cert_date: '',
					contractor_cert_nr: '',
					contractor_cert_nr_prefix: '',
					contractor_insurance_date: '',
					contractor_insurance_date_to: '',
					contractor_insurance_nr: '',
					contractor_house: '',
					contractor_appartment: '',
					contractor_housing: '',
					contractor_insurer: '',
					obj_work_supervisor_title: '',
					obj_work_supervisor_nr: '',
					obj_work_supervisor_nr_company: ''
				};
				break;
			case 7:
				$scope.form_id = 2;
				$scope.resetContractorCertNr();
				$scope.storedParams = {
					contractor_name: '',
					rangovo_v_pavarde: '',
					contractor_address: '',
					contractor_address_id: '',
					contractor_address_municipality: '',
					contractor_address_city: '',
					contractor_address_street: '',
					contractor_phone: '',
					contractor_email: '',
					contractor_cert_date: '',
					contractor_cert_nr: ''
				};
				break;
			case 8:
				$scope.form_id = 7;
				break;
			case 9:
				$scope.form_id = 4;
				$scope.storedParams = {
					contractor_name: '',
					vert_rangovo_atstovo_email: '',
					vert_rangovo_atstovo_tel: ''
				};
				break;
			case 10:
				$scope.form_id = 5;
				break;
			case 11:
				$scope.form_id = 8;
				$scope.storedParams = {
					contractor_name: '',
					contractor_address: '',
					contractor_address_id: '',
					contractor_address_municipality: '',
					contractor_address_city: '',
					contractor_address_street: '',
					contractor_house: '',
					contractor_appartment: '',
					contractor_housing: '',
					contractor_phone: '',
					contractor_email: '',
					contractor_cert_date: '',
					contractor_cert_nr: '',
					contractor_insurance_date: '',
					contractor_insurance_date_to: '',
					contractor_insurance_nr: '',
					obj_work_supervisor_title: '',
					obj_work_supervisor_nr: '',
					obj_work_supervisor_nr_company: '',
					contractor_insurer: ''
				};
				break;
			default:
				$scope.form_id = 0;
		}


		document.querySelector('.main-content').scrollIntoView({
			behavior: 'smooth'
		});
	};

	$scope.clearStorageData = function (e) {
		e.preventDefault();
		localStorage.removeItem(`helpdesk_forma_${$scope.form_id}`);
	};

	$scope.isSavedFormData = function () {
		if(parseInt($scope.form_id)>0){
			let d = localStorage.getItem(`helpdesk_forma_${$scope.form_id}`);
			if(d){
				return true;
			}
		}
		return false;
	};

	$scope.setFormParamsFromLs = function (e) {
		e.preventDefault();
		if(parseInt($scope.form_id)>0 && $scope.isSavedFormData()){
			localStorageService.init(`helpdesk_forma_${$scope.form_id}`,{params:$scope.storedParams});
			angular.forEach(angular.copy(localStorageService.getParam('params')), function(value, key) {
				if(parseInt($scope.form_id) === 8){
					$scope.form_8_fields[key] = value;
				}
				else{
					$scope[key] = value;
				}
			});
			$scope.openContractorAddressHolder();
		}

	};

	$scope.openContractorAddressHolder = function () {
		var activeEl = $('.address-search-component-holder.contractor-address');
		activeEl.find('.input-wrapper:not(.custom-address),.hide-address-inputs').show();
		activeEl.find('.type_b').hide();
		activeEl.find('select.select2').select2('close');
	};

	$scope.resetForm = function () {
		// Scroll to the <main> element
		var element = document.querySelector('main');
		if (element) {
			element.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
		$scope.stepBack({back_id: 0});
		$scope.uploaded_files = [];
		$scope.situation_title = [];
		$scope.uploads_count = 0;
		$scope.$broadcast('cancelFiles');
	};

	$scope.stepBack = function (btn) {
		// Scroll to the <main> element
		var element = document.querySelector('main');
		if (element) {
			element.scrollIntoView({behavior: 'smooth', block: 'start'});
		}
		$scope.checking_nr = false;
		$scope.objContractNrValid = false;
		$scope.check_obj_contract_nr = '';
		$scope.check_data = {};
		$scope.iframeSrc = '';
		if (btn.back_id >= 0) {
			btn.question_id = btn.back_id;
			for (var i = 0, len = $scope.navigation.length; i < len; i++) {
				if ($scope.navigation[i].id == btn.question_id) {
					$scope.id = i;
					break;
				}
			}
			$scope.displayStatus = btn.question_id;

			if ($scope.situation_title.length > 0) {
				$scope.situation_title.splice($scope.situation_title.length - 1, 1);
			}
		} else {
			$scope.navigation = jsHelpdesk.navigation;
			$scope.setDisplayStatus(0);
		}
		if($scope.displayStatus==1){
			$scope.resetContractorCertNr();
		}
	};

	$scope.backToEdit = function () {
		$scope.checking_nr = false;
		$scope.objContractNrValid = false;
		$scope.check_obj_contract_nr = '';
		$scope.check_data = {};
		if ($scope.situation_title.length > 0) {
			$scope.situation_title.splice($scope.situation_title.length - 1, 1);
		}
		switch ($scope.form_id) {
			case 1:
				$scope.setDisplayStatus(6);
				break;
			case 2:
				$scope.setDisplayStatus(7);
				break;
			case 7:
				$scope.setDisplayStatus(8);
				break;
			case 4:
				$scope.setDisplayStatus(9);
				break;
			case 5:
				$scope.setDisplayStatus(10);
				break;
			case 8:
				$scope.setDisplayStatus(11);
				break;
			default:
				$scope.form_id = 0;
		}
		$interval.cancel(interval);
		$scope.dokobitFileId = '';
		$scope.iframe_height = '1000px';
		$scope.dokobit_state = 0;

	};

	$scope.goBackToDisplayStatus = function (status) {
		    // Scroll to the <main> element
		var element = document.querySelector('main');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		if (typeof(arguments[1])!=='undefined' && arguments[1] && $scope.situation_title.length > 0) {
			$scope.situation_title.splice($scope.situation_title.length - 1, 1);
		}
		if($scope.displayStatus === 81 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)<10)){
			$scope.displayStatus = 8;
		}
		else if($scope.displayStatus === 84 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)<10)){
			$scope.displayStatus = 81;
		}
		else if($scope.displayStatus === 84 && (typeof($scope.n32)==='undefined' || (parseFloat($scope.n32)<12 && parseFloat($scope.n32)>9))){
			$scope.displayStatus = 82;
		}
		else if($scope.displayStatus === 83 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)>=12)){
			$scope.displayStatus = 82;
		}
		else if($scope.displayStatus === 805 && (typeof($scope.form_8_fields.pmax_kw)!=='undefined' && parseFloat($scope.form_8_fields.pmax_kw)>100)){
			$scope.displayStatus = 803;
		}
		else{
			$scope.displayStatus = status;
		}
	};

	$scope.gotoDisplayStatus = function (e,status) {
		e.preventDefault();
	    // Scroll to the <main> element
		var element = document.querySelector('main');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		if($scope.displayStatus === 8 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)<10)){
			$scope.displayStatus = 81;
		}
		else if($scope.displayStatus === 81 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)<10)){
			$scope.displayStatus = 84;
		}
		else if($scope.displayStatus === 82 && (typeof($scope.n32)==='undefined' || (parseFloat($scope.n32)<12 && parseFloat($scope.n32)>9))){
			$scope.displayStatus = 84;
		}
		else if($scope.displayStatus === 82 && (typeof($scope.n32)==='undefined' || parseFloat($scope.n32)>=12)){
			$scope.displayStatus = 83;
		}
		else if($scope.displayStatus === 803 && (typeof($scope.form_8_fields.pmax_kw)!=='undefined' && parseFloat($scope.form_8_fields.pmax_kw)>100)){
			//skip page 5
			$scope.displayStatus = 805;
		}
		else{
			$scope.displayStatus = status;
		}
	};

	$scope.resetContractorCertNr = function () {
		if($scope.form_id == 1){
			$scope.contractor_cert_nr_prefix = 'EI-';
		}
		else{
			$scope.contractor_cert_nr_prefix = 'E-';
		}
		$scope.updateContractorCertNr();
	};

	$scope.getIconPath = function (form) {
		if (form.image) {
			return form.image;
		}
		return form.icon2;
	};

	$scope.explicitlyTrustedHtml = function (text) {
		return $sce.trustAsHtml(text);
	};

	$scope.checkObjContractNr = function (check_obj_contract_nr) {
		$scope.checking_nr = true;
		$scope.iframeSrc = '';
		if ($scope.nrCheckUrl !== '' && check_obj_contract_nr !== '') {
			$http({
				method: 'POST',
				url: $scope.nrCheckUrl,
				data: {
					nr: check_obj_contract_nr
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				$scope.objContractNrValid = response.data.success;
				if (response.data.success) {
					$scope.check_data = response.data.data;
					$scope.situation_title.push('<strong>' + helpdesk_dokumento_nr + '</strong> ' + response.data.nr);
					$scope.setDisplayStatus(3);
					if (response.data.iframe_url) {
						$scope.iframeSrc = $sce.trustAsResourceUrl(response.data.iframe_url);
					}
				} else {
					$scope.error_message = response.data.message;
				}
			}, function (response) {
				console.log(['Error', response]);
			}).then(function () {
				$scope.checking_nr = false;
			});
		}
	};

	getAddressFromSelect("ContractorAddress");
	getAddressFromSelect("ContractorAddressForm8");
	getAddressFromSelect("ObjAddress");
	getAddressFromSelect("ObjAddressForm8");

	function getAddressFromSelect(inputId) {
		var btn_not_found = $('#' + inputId + 'NotFound');
		var btn_keep_typing = $('#' + inputId + 'KeepTyping');
		var suggestions = $('#' + inputId + 'Suggestions');
		btn_not_found.hide();
		btn_keep_typing.hide();
		//$('#add' + inputId + 'Container').hide();
		if (suggestions.hasClass('vis_hidden')) {
			suggestions.hide();
			$('#add' + inputId + 'Container').show();
		}

		setTimeout(function () {
			if ($('#' + inputId).length) {
				$('#' + inputId).select2({
					//				"minimumResultsForSearch" : -1
					language: {
						noResults: function () {
							return`
		<div class="address-not-found-wrapper">
			<div class="address-not-found">
				<div class="title">
					Neradote savo adreso?
				</div>
				<div class="subtitle">
					<i class='icon icon-phone'></i>
					<span>Spauskite</span>
					<strong><a class='show-address-inputs'>čia</a></strong>
				</div>
			</div>
		</div>`;
							switch (navigator.language || navigator.userLanguage) {
								case "lt":
									return "Atitikmenų nerasta";
								case "en":
									return "No results found";
								default:
									return "Atitikmenų nerasta";
							}
						},
						inputTooShort: function (args) {
							const remainingChars = args.minimum - args.input.length;
							let message = `Įrašykite dar ${remainingChars} simbol${remainingChars === 1 ? 'į' : 'ius'}`;
							return message;
						},
						searching: function () {
							return "Ieškoma...";
						}
					},
					escapeMarkup: function (markup) {
						return markup;
					},
					placeholder: {
						id: '-1', // the value of the option
						text: helpdesk_address
					},
					minimumInputLength: 3,
					ajax: {
						url: address_suggestions_url,
						delay: 300,
						cache: true,
						data: function (params) {

							var query = {
								address: params.term
//								action: 'address'
							};
							// Query parameters will be ?address=[term]&action=address
							return query;
						},
						processResults: function (data) {
							var r = [];
							if (data && data.success && data.items) {
								for (var i = 0, l = data.items.length; i < l; i++) {
									if (data.items[i]._source.adr_sudetinis_adresas == '') {
										continue;
									}

									r.push({
										text: data.items[i]._source.adr_sudetinis_adresas,
										id: data.items[i]._id,
										muni: typeof (data.items[i]._source.adr_savivaldybe) !== 'undefined' ? data.items[i]._source.adr_savivaldybe : '',
										city: typeof (data.items[i]._source.adr_miestas_kaimas) !== 'undefined' ? data.items[i]._source.adr_miestas_kaimas : '',
										street: typeof (data.items[i]._source.adr_gatve) !== 'undefined' ? data.items[i]._source.adr_gatve : '',
										house: typeof (data.items[i]._source.adr_vieta) !== 'undefined' ? data.items[i]._source.adr_vieta : '',
										appartment: typeof (data.items[i]._source.adr_patalpos_numeris) !== 'undefined' ? data.items[i]._source.adr_patalpos_numeris : ''
									});
								}
								if (data.items.length < 1) {
									btn_not_found.show();
									btn_keep_typing.hide();
								} else {
									btn_not_found.show();
									btn_keep_typing.hide();
								}
							} else if (data && !data.success) {
							}
							if (r.length == 0) {
								btn_not_found.show();
								btn_keep_typing.hide();
							}
							return {
								results: r
							};
						}
					}
				}).on('select2:selecting', function (e, action) {
					$('#' + inputId).parent().find("input.address_id").val(e.params.args.data.id);
					$('#' + inputId).parent().find("input.address_text").val(e.params.args.data.text);
					if (inputId === 'ContractorAddress') {
						$scope.contractor_address = e.params.args.data.text;
						$scope.contractor_address_id = e.params.args.data.id;
						$scope.contractor_address_municipality = e.params.args.data.muni;
						$scope.contractor_address_city = e.params.args.data.city;
						$scope.contractor_address_street = e.params.args.data.street;
						$scope.contractor_house = e.params.args.data.house;
						$scope.contractor_appartment = e.params.args.data.appartment;
					}
					if (inputId === 'ContractorAddressForm8') {
						$scope.form_8_fields.contractor_address = e.params.args.data.text;
						$scope.form_8_fields.contractor_address_id = e.params.args.data.id;
						$scope.form_8_fields.contractor_address_municipality = e.params.args.data.muni;
						$scope.form_8_fields.contractor_address_city = e.params.args.data.city;
						$scope.form_8_fields.contractor_address_street = e.params.args.data.street;
						$scope.form_8_fields.contractor_house = e.params.args.data.house;
						$scope.form_8_fields.contractor_appartment = e.params.args.data.appartment;
					}
					if (inputId === 'ObjAddress') {
						$scope.obj_address = e.params.args.data.text;
						$scope.obj_address_id = e.params.args.data.id;
						$scope.obj_address_municipality = e.params.args.data.muni;
						$scope.obj_address_city = e.params.args.data.city;
						$scope.obj_address_street = e.params.args.data.street;
						$scope.obj_house = e.params.args.data.house;
						$scope.obj_appartment = e.params.args.data.appartment;
					}
					if (inputId === 'ObjAddressForm8') {
						$scope.form_8_fields.obj_address = e.params.args.data.text;
						$scope.form_8_fields.obj_address_id = e.params.args.data.id;
						$scope.form_8_fields.obj_address_municipality = e.params.args.data.muni;
						$scope.form_8_fields.obj_address_city = e.params.args.data.city;
						$scope.form_8_fields.obj_address_street = e.params.args.data.street;
						$scope.form_8_fields.obj_house = e.params.args.data.house;
						$scope.form_8_fields.obj_appartment = e.params.args.data.appartment;
					}
					$scope.$apply();
					$('#' + inputId + '_house').prop('required', true);
					btn_keep_typing.hide();
					btn_not_found.hide();
				});

				//Restore submited values
				//			$('select.select2').each(function(){
				//			var value = $('#' + inputId).parent().find("input.address_text").val();

				//			if (typeof value === 'string' && value !== '') {
				//				var $option = $('<option selected="selected"></option>').text(value).val(value);
				//				$('#' + inputId).append($option).trigger('change');
				//			}
				//			});
			}
		}, 200);
	}

	$scope.sumIrengtuIrenginiuSumineGalia = function () {
		if (!isNaN(parseFloat($scope.kaupiklio_galia_kw)) && !isNaN(parseFloat($scope.obj_new_installed_power)) && parseInt($scope.form_id) === 5) {
			const irengtu_irenginiu_sumine_galia = (parseFloat($scope.kaupiklio_galia_kw) + parseFloat($scope.obj_new_installed_power)).toFixed(2);
			$scope.irengtu_irenginiu_sumine_galia = irengtu_irenginiu_sumine_galia;
		}
	};

	SessionService.init();

	$scope.$on('$destroy', function() {
	  SessionService.stop();
	});

	$scope.form8Page1Valid = function () {
		if($scope.form_8_fields.contractor_address === '' && ($scope.form_8_fields.contractor_address_municipality === '' || $scope.form_8_fields.contractor_address_city === '' || $scope.form_8_fields.contractor_house === '')){
			return false;
		}

		if(!$scope.form8ContractorDateValid()){
			return false;
		}
		return true;
	};

	$scope.form8Page2Valid = function () {
		if($scope.form_8_fields.obj_address === '' && ($scope.form_8_fields.obj_address_municipality === '' || $scope.form_8_fields.obj_address_city === '' || $scope.form_8_fields.obj_house === '')){
			return false;
		}

		if(!$scope.form8ContractorDateValid()){
			return false;
		}
		return true;
	};

	$scope.form8Page3Valid = function () {
		var error = false;
		$scope.form_8_fields.itampos_keitikliai.forEach(function(keitiklis) {
//			if(!$scope.elektrinesSumineIrengtojiGaliaValid(keitiklis)){
//				error=true;
//				return;
//			}
			if($scope.form8Page3ElektrinesInfoRequired(keitiklis)){
				if(!$scope.elektrinesSumineLeistinaGaliaValid(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.elektrinesSumineLeistinaGaliaValid2(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.elektrinesSumineLeistinaGaliaValid3(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.elektrinesSumineLeistinaGaliaValid4(keitiklis)){
					error=true;
					return;
				}
			}
			if($scope.form8Page3HibridineInfoRequired(keitiklis)){
//				if(!$scope.helektrinesSumineIrengtojiGaliaValid(keitiklis)){
//					error=true;
//					return;
//				}
				if(!$scope.helektrinesSumineLeistinaGaliaValid(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.helektrinesSumineLeistinaGaliaValid2(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.helektrinesSumineLeistinaGaliaValid3(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.helektrinesSumineLeistinaGaliaValid4(keitiklis)){
					error=true;
					return;
				}
			}
			if($scope.form8Page3KaupimoIrenginioInfoRequired(keitiklis)){
//				if(!$scope.irenginioSumineIrengtojiGaliaValid(keitiklis)){
//					error=true;
//					return;
//				}
				if(!$scope.irenginioSumineLeistinaGaliaValid(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.irenginioSumineLeistinaGaliaValid2(keitiklis)){

					error=true;
					return;
				}
				if(!$scope.irenginioSumineLeistinaGaliaValid3(keitiklis)){
					error=true;
					return;
				}
				if(!$scope.irenginioSumineLeistinaGaliaValid4(keitiklis)){

					error=true;
					return;
				}
			}

		});
		if(error){
			return false;
		}
		return true;
	};

	$scope.form8Page4Valid = function () {
		if(!$scope.form8ParamLessZero('pmax_kw')){
			return false;
		}
		if(!$scope.form8LeistinaGeneruotiGaliaValid() || !$scope.form8LeistinaGeneruotiGaliaValid2() || !$scope.form8LeistinaGeneruotiGaliaValid3()){
			return false;
		}
		return true;
	};

	$scope.form8Page5Valid = function () {
		if(!$scope.form8pmaxmaziau10kwhzValid()){
			return false;
		}
		if(!$scope.form8pmaxmaziau10kwtValid()){
			return false;
		}
		if(!$scope.form8pmax_daugiau_10kw_hzValid()){
			return false;
		}
		if(!$scope.form8pmax_daugiau_10kw_tValid()){
			return false;
		}
		if(!$scope.form8pmax_2f_daugiau_10kw_hzValid()){
			return false;
		}
		if(!$scope.form8daznis_1f_hzValid()){
			return false;
		}
		if(!$scope.form8daznis_1f_tValid()){
			return false;
		}
		if(!$scope.form8daznis_2f_hzValid()){
			return false;
		}
		if(!$scope.form8apsauga_nuo_daznio_kitimo_spartosValid()){
			return false;
		}
		if(!$scope.form8auto_prijungimas_po_atistatymoValid()){
			return false;
		}
		if(!$scope.form8itampa_x_1Valid()){
			return false;
		}
		if(!$scope.form8itampa_x_2Valid()){
			return false;
		}
		if(!$scope.form8itampa_x_3Valid()){
			return false;
		}
		if(!$scope.form8itampa_x_4Valid()){
			return false;
		}
		return true;
	};

//	$scope.form8ActDateValid = function () {
//		if ($scope.form_8_fields.act_date > $scope.form_8_fields.contractor_insurance_date_to || $scope.form_8_fields.act_date < $scope.form_8_fields.contractor_insurance_date) {
//			return false;
//		}
//		return true;
//	};

	$scope.form8Page1FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==11);
	};

	$scope.form8Page2FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==801);
	};

	$scope.form8Page3FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==802);
	};

	$scope.form8Page4FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==803);
	};

	$scope.form8Page5FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==804);
	};

	$scope.form8Page6FieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==805);
	};

	$scope.form8RequireSignedFileVisible = function () {
		return ($scope.form_id==8 && $scope.displayStatus==805 && parseFloat($scope.form_8_fields.pmax_kw) <= 10);
	};

	$scope.form8Page5FieldRequired2 = function () {
		return ($scope.form_id==8 && $scope.displayStatus==804 && parseFloat($scope.form_8_fields.pmax_kw)<10);
	};

	$scope.form8Page5FieldRequired3 = function () {
		return ($scope.form_id==8 && $scope.displayStatus==804 && parseFloat($scope.form_8_fields.pmax_kw)>=10);
	};

	$scope.form8Page3FotomoduliuTipasRequired = function (keitiklis) {
		return ($scope.form_id==8 && $scope.displayStatus==802 && keitiklis.istekliu_rusis==='saules');
	};

	$scope.form8Page4GasKiekisRequired = function () {
//		if(!($scope.form_id==8 && $scope.displayStatus==803 && parseFloat($scope.form_8_fields.obj_sumine_irengtoji_galia)>30)){
//			$scope.form_8_fields.obj_gas_kiekis = '';
//		}
//		return ($scope.form_id==8 && $scope.displayStatus==803 && parseFloat($scope.form_8_fields.obj_sumine_irengtoji_galia)>30);
		return ($scope.form_id==8 && $scope.displayStatus==803 && parseFloat($scope.form_8_fields.pmax_kw)>100 && (parseFloat($scope.form_8_fields.obj_total_power) > (0.05 * parseFloat($scope.form_8_fields.pmax_kw))));
	};

	$scope.form8Page3HFotomoduliuTipasRequired = function (keitiklis) {
		return ($scope.form_id==8 && $scope.displayStatus==802 && keitiklis.h_istekliu_rusis==='saules');
	};

	$scope.form8Page3ElektrinesInfoRequired = function (keitiklis) {
		return ($scope.form_id==8 && $scope.displayStatus==802 && (typeof(keitiklis.irenginiai)!=='undefined' && keitiklis.irenginiai !== 'kaupimo'));
	};

	$scope.form8Page3KaupimoIrenginioInfoRequired = function (keitiklis) {
		return ($scope.form_id==8 && $scope.displayStatus==802 && (keitiklis.irenginiai === 'hibridine_kaup' || keitiklis.irenginiai === 'elektrine_kaup' || keitiklis.irenginiai === 'kaupimo'));
	};

	$scope.form8Page3HibridineInfoRequired = function (keitiklis) {
		return ($scope.form_id==8 && $scope.displayStatus==802 && (keitiklis.irenginiai === 'hibridine' || keitiklis.irenginiai === 'hibridine_kaup'));
	};

	$scope.form8Page6SchemeNumberFieldRequired = function () {
		return ($scope.form_id==8 && $scope.displayStatus==805 && parseFloat($scope.form_8_fields.pmax_kw)>100);
	};

	$scope.form8ContractorDateValid = function () {
		if ($scope.form_8_fields.contractor_insurance_date > $scope.form_8_fields.contractor_insurance_date_to) {
			return false;
		}
		return true;
	};

	$scope.itampos_keitikliu_kiekis = [
		{ id: 1, title: "1" },
		{ id: 2, title: "2" },
		{ id: 3, title: "3" },
		{ id: 4, title: "4" },
		{ id: 5, title: "5" },
		{ id: 6, title: "6" }
	];
	$scope.obj_gas_kiekiai = jsHelpdesk.obj_gas_kiekiai;
	$scope.form_8_fields.keitikliu_kiekis_objekte = 1;
	$scope.form_8_fields.itampos_keitikliai = [];

	$scope.$watch('form_8_fields.keitikliu_kiekis_objekte', function (newVal) {
		$scope.form_8_fields.itampos_keitikliai = new Array(parseInt(newVal)).fill().map(() => ({
			vardine_aktyvioji_galia: '',
			itampa: '',
			modelis: '',
			irenginiai: '',
			istekliu_rusis: '',
			istekliu_rusis_kita: '',
//			nutolusi_elektrine: false,
			fotomoduliu_tipas: '',
			elektrines_esama_irengtoji_galia: '',
			elektrines_nauja_irengtoji_galia: '',
			elektrines_sumine_irengtoji_galia: '',
			elektrines_esama_leistina_generuoti_galia: '',
			elektrines_nauja_leistina_generuoti_galia: '',
			elektrines_sumine_leistina_generuoti_galia: '',
			elektrines_pmax: '',
			h_istekliu_rusis: '',
			h_istekliu_rusis_kita: '',
//			h_nutolusi_elektrine: false,
			h_fotomoduliu_tipas: '',
			h_elektrines_esama_irengtoji_galia: '',
			h_elektrines_nauja_irengtoji_galia: '',
			h_elektrines_sumine_irengtoji_galia: '',
			h_elektrines_esama_leistina_generuoti_galia: '',
			h_elektrines_nauja_leistina_generuoti_galia: '',
			h_elektrines_sumine_leistina_generuoti_galia: '',
			h_elektrines_pmax: '',
			irenginio_esama_irengtoji_galia: '',
			irenginio_nauja_irengtoji_galia: '',
			irenginio_sumine_irengtoji_galia: '',
			irenginio_esama_leistina_generuoti_galia: '',
			irenginio_nauja_leistina_generuoti_galia: '',
			irenginio_sumine_leistina_generuoti_galia: '',
			irenginio_esama_talpa: '',
			irenginio_nauja_talpa: '',
			irenginio_esama_chemine_sudetis: '',
			irenginio_esama_chemine_sudetis_kita: '',
			irenginio_nauja_chemine_sudetis: '',
			irenginio_nauja_chemine_sudetis_kita: '',
			irenginio_esamas_modelis: '',
			irenginio_naujas_modelis: '',
			irenginio_pmax: ''
		}));
	});

	$scope.clearIrenginioInfo = function (index) {
		const item = $scope.form_8_fields.itampos_keitikliai[index];
		if (!item){
			return;
		}
		for (let key in item) {
			if (key!=='irenginiai' && key!=='vardine_aktyvioji_galia' && key!=='nominalioji_itampa' && key!=='modelis' && item.hasOwnProperty(key)) {
				item[key] = ''; // clear value
			}
		}
	};

	$scope.$watch('form_8_fields.itampos_keitikliai', function(newVal) {
		if (!newVal) return;

		let totalSumineIrengtojiGalia = 0;
		let totalSumineLeistinaGalia = 0;
		let totalSumineKeitikliuAktyvGalia = 0;
		let totalMaxPmax = 0;
		let pmaxKw = 0;
		newVal.forEach(function(keitiklis) {
			let esama_iren = parseFloat(keitiklis.elektrines_esama_irengtoji_galia) || 0;
			let nauja_iren = parseFloat(keitiklis.elektrines_nauja_irengtoji_galia) || 0;
			keitiklis.elektrines_sumine_irengtoji_galia = (esama_iren + nauja_iren).toFixed(3);

			let esama_leist = parseFloat(keitiklis.elektrines_esama_leistina_generuoti_galia) || 0;
			let nauja_leist = parseFloat(keitiklis.elektrines_nauja_leistina_generuoti_galia) || 0;
			keitiklis.elektrines_sumine_leistina_generuoti_galia = (esama_leist + nauja_leist).toFixed(3);

			keitiklis.elektrines_pmax = Math.min(parseFloat(keitiklis.elektrines_sumine_irengtoji_galia), parseFloat(keitiklis.vardine_aktyvioji_galia));
			let irenginio_sumine = 0;
			let irenginio_sumine_leistina = 0;
			let irenginio_pmax = 0;
			if($scope.form8Page3KaupimoIrenginioInfoRequired(keitiklis)){
				let kaupimo_esama = parseFloat(keitiklis.irenginio_esama_irengtoji_galia) || 0;
				let kaupimo_nauja = parseFloat(keitiklis.irenginio_nauja_irengtoji_galia) || 0;
				keitiklis.irenginio_sumine_irengtoji_galia = (kaupimo_esama + kaupimo_nauja).toFixed(3);

				let irenginio_esama = parseFloat(keitiklis.irenginio_esama_leistina_generuoti_galia) || 0;
				let irenginio_nauja = parseFloat(keitiklis.irenginio_nauja_leistina_generuoti_galia) || 0;
				keitiklis.irenginio_sumine_leistina_generuoti_galia = (irenginio_esama + irenginio_nauja).toFixed(3);

				keitiklis.irenginio_pmax = Math.min(parseFloat(keitiklis.irenginio_sumine_irengtoji_galia), parseFloat(keitiklis.vardine_aktyvioji_galia));
				irenginio_pmax = parseFloat(keitiklis.irenginio_pmax) || 0;
				irenginio_sumine = parseFloat(keitiklis.irenginio_sumine_irengtoji_galia) || 0;
				irenginio_sumine_leistina = parseFloat(keitiklis.irenginio_sumine_leistina_generuoti_galia) || 0;
			}
			let h_irenginio_pmax = 0;
			if($scope.form8Page3HibridineInfoRequired(keitiklis)){
				let h_esama_iren = parseFloat(keitiklis.h_elektrines_esama_irengtoji_galia) || 0;
				let h_nauja_iren = parseFloat(keitiklis.h_elektrines_nauja_irengtoji_galia) || 0;
				keitiklis.h_elektrines_sumine_irengtoji_galia = (h_esama_iren + h_nauja_iren).toFixed(3);

				let h_esama_leist = parseFloat(keitiklis.h_elektrines_esama_leistina_generuoti_galia) || 0;
				let h_nauja_leist = parseFloat(keitiklis.h_elektrines_nauja_leistina_generuoti_galia) || 0;
				keitiklis.h_elektrines_sumine_leistina_generuoti_galia = (h_esama_leist + h_nauja_leist).toFixed(3);

				keitiklis.h_elektrines_pmax = Math.min(parseFloat(keitiklis.h_elektrines_sumine_irengtoji_galia), parseFloat(keitiklis.vardine_aktyvioji_galia));
				h_irenginio_pmax = parseFloat(keitiklis.h_elektrines_pmax) || 0;

			}
			totalSumineIrengtojiGalia += parseFloat(keitiklis.elektrines_sumine_irengtoji_galia) || 0;
			totalSumineIrengtojiGalia += irenginio_sumine;
			totalSumineLeistinaGalia += parseFloat(keitiklis.elektrines_sumine_leistina_generuoti_galia) || 0;
			totalSumineLeistinaGalia += irenginio_sumine_leistina;

			totalSumineKeitikliuAktyvGalia += parseFloat(keitiklis.vardine_aktyvioji_galia) || 0;

			pmaxKw = Math.min((parseFloat(keitiklis.elektrines_pmax) || 0) + irenginio_pmax + h_irenginio_pmax, parseFloat(keitiklis.vardine_aktyvioji_galia));
			totalMaxPmax += pmaxKw;

		});

		$scope.form_8_fields.obj_sumine_irengtoji_galia = totalSumineIrengtojiGalia.toFixed(3);
//		$scope.form_8_fields.leistina_generuoti_galia = totalSumineLeistinaGalia.toFixed(2);

		$scope.form_8_fields.obj_sumine_keitikliu_aktyv_galia = totalSumineKeitikliuAktyvGalia.toFixed(3);
		$scope.form_8_fields.pmax_kw = totalMaxPmax.toFixed(3);
		$scope.form_8_fields.leistina_generuoti_galia = Math.min(parseFloat(totalSumineLeistinaGalia.toFixed(3)), parseFloat($scope.form_8_fields.pmax_kw));
	}, true);

	$scope.$watch('form_8_fields.pmax_kw', function(newVal) {
		if (parseFloat(newVal) > 10) {
			$scope.form_8_fields.require_signed_file = false;
		}
	});

	$scope.isFieldInvalid = function(form, index, fieldName) {
		var field = form["itampos_keitikliai[" + (index + 1) + "][" + fieldName + "]"];
		return field && field.$error.required && field.$touched;
	};

//	$scope.elektrinesSumineIrengtojiGaliaValid = function(keitiklis) {
//		if (parseInt($scope.form_id) === 8) {
//			if (typeof (keitiklis.elektrines_sumine_irengtoji_galia) !== 'undefined') {
//				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
//					if (parseFloat(keitiklis.elektrines_sumine_irengtoji_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
//						return false;
//					}
//				}
//			}
//		}
//		return true;
//	};

//	$scope.helektrinesSumineIrengtojiGaliaValid = function(keitiklis) {
//		if (parseInt($scope.form_id) === 8) {
//			if (typeof (keitiklis.h_elektrines_sumine_irengtoji_galia) !== 'undefined') {
//				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
//					if (parseFloat(keitiklis.h_elektrines_sumine_irengtoji_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
//						return false;
//					}
//				}
//			}
//		}
//		return true;
//	};

	$scope.elektrinesSumineLeistinaGaliaValid = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.vardine_aktyvioji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.elektrines_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.vardine_aktyvioji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.elektrinesSumineLeistinaGaliaValid2 = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.elektrines_sumine_irengtoji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.elektrines_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.elektrines_sumine_irengtoji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.elektrinesSumineLeistinaGaliaValid3 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if($scope.form_8_fields.nutolusi_elektrine){
				return true;
			}
			if (typeof (keitiklis.elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
					if (parseFloat(keitiklis.elektrines_sumine_leistina_generuoti_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
						return false;
					}
				}
			}

		}
		return true;
	};

	$scope.elektrinesSumineLeistinaGaliaValid4 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.nominalioji_itampa) !== 'undefined' && parseFloat(keitiklis.nominalioji_itampa) === 0.23 && typeof (keitiklis.elektrines_sumine_leistina_generuoti_galia) !== 'undefined' && parseFloat(keitiklis.elektrines_sumine_leistina_generuoti_galia) > 3.6) {
				return false;
			}

		}
		return true;
	};

	$scope.helektrinesSumineLeistinaGaliaValid = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.h_elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.vardine_aktyvioji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.h_elektrines_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.vardine_aktyvioji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.helektrinesSumineLeistinaGaliaValid2 = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.h_elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.h_elektrines_sumine_irengtoji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.h_elektrines_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.h_elektrines_sumine_irengtoji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.helektrinesSumineLeistinaGaliaValid3 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if($scope.form_8_fields.nutolusi_elektrine){
				return true;
			}
			if (typeof (keitiklis.h_elektrines_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
					if (parseFloat(keitiklis.h_elektrines_sumine_leistina_generuoti_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
						return false;
					}
				}
			}

		}
		return true;
	};

	$scope.helektrinesSumineLeistinaGaliaValid4 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.nominalioji_itampa) !== 'undefined' && parseFloat(keitiklis.nominalioji_itampa) === 0.23 && typeof (keitiklis.elektrines_sumine_leistina_generuoti_galia) !== 'undefined' && parseFloat(keitiklis.h_elektrines_sumine_leistina_generuoti_galia) > 3.6) {
				return false;
			}

		}
		return true;
	};

//	$scope.irenginioSumineIrengtojiGaliaValid = function(keitiklis) {
//		if (parseInt($scope.form_id) === 8) {
//			if (typeof (keitiklis.irenginio_sumine_irengtoji_galia) !== 'undefined') {
//				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
//					if (parseFloat(keitiklis.irenginio_sumine_irengtoji_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
//						return false;
//					}
//				}
//			}
//		}
//		return true;
//	};

	$scope.irenginioSumineLeistinaGaliaValid = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.irenginio_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.vardine_aktyvioji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.irenginio_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.vardine_aktyvioji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.irenginioSumineLeistinaGaliaValid2 = function(keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.irenginio_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof (keitiklis.irenginio_sumine_irengtoji_galia) !== 'undefined') {
					if (parseFloat(keitiklis.irenginio_sumine_leistina_generuoti_galia) > parseFloat(keitiklis.irenginio_sumine_irengtoji_galia)) {
						return false;
					}
				}
			}
		}
		return true;
	};

	$scope.irenginioSumineLeistinaGaliaValid3 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if($scope.form_8_fields.nutolusi_elektrine){
				return true;
			}
			if (typeof (keitiklis.irenginio_sumine_leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
					if (parseFloat(keitiklis.irenginio_sumine_leistina_generuoti_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
						return false;
					}
				}
			}

		}
		return true;
	};

	$scope.irenginioSumineLeistinaGaliaValid4 = function (keitiklis) {
		if (parseInt($scope.form_id) === 8) {
			if (typeof (keitiklis.nominalioji_itampa) !== 'undefined' && parseFloat(keitiklis.nominalioji_itampa) === 0.23 && typeof (keitiklis.irenginio_sumine_leistina_generuoti_galia) !== 'undefined' && parseFloat(keitiklis.irenginio_sumine_leistina_generuoti_galia) > 3.6) {
				return false;
			}

		}
		return true;
	};

	$scope.form8LeistinaGeneruotiGaliaValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if (typeof ($scope.form_8_fields.leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.form_8_fields.obj_sumine_irengtoji_galia) !== 'undefined') {
					if (parseFloat($scope.form_8_fields.leistina_generuoti_galia) > parseFloat($scope.form_8_fields.obj_sumine_irengtoji_galia)) {
						return false;
					}
				}
//				if (typeof ($scope.form_8_fields.pmax_kw) !== 'undefined') {
//					if (parseFloat($scope.form_8_fields.leistina_generuoti_galia) > parseFloat($scope.form_8_fields.pmax_kw)) {
//						return false;
//					}
//				}
				return true;
			}

			return false;
		}
		return true;
	};

	$scope.form8LeistinaGeneruotiGaliaValid2 = function () {
		if (parseInt($scope.form_id) === 8) {
			if($scope.form_8_fields.nutolusi_elektrine){
				return true;
			}
			if (typeof ($scope.form_8_fields.leistina_generuoti_galia) !== 'undefined') {
				if (typeof ($scope.form_8_fields.obj_total_power) !== 'undefined') {
					if (parseFloat($scope.form_8_fields.leistina_generuoti_galia) > parseFloat($scope.form_8_fields.obj_total_power)) {
						return false;
					}
				}
				return true;
			}

			return false;
		}
		return true;
	};

	$scope.form8LeistinaGeneruotiGaliaValid3 = function () {
		var invalid = false;
		if (parseInt($scope.form_id) === 8) {
			$scope.form_8_fields.itampos_keitikliai.forEach(function(keitiklis) {
				if (typeof (keitiklis.nominalioji_itampa) !== 'undefined' && parseFloat(keitiklis.nominalioji_itampa) === 0.23 && typeof ($scope.form_8_fields.leistina_generuoti_galia) !== 'undefined' && parseFloat($scope.form_8_fields.leistina_generuoti_galia) > 3.6) {
					invalid = true;
				}
			});

		}
		if(invalid){
			return false;
		}
		return true;
	};

	$scope.form8ParamIn100Scope = function (param) {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields[param]) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields[param]))){
				return false;
			}
			if (typeof ($scope.form_8_fields[param]) !== 'undefined' && (parseFloat($scope.form_8_fields[param]) < 0 || parseFloat($scope.form_8_fields[param]) > 100)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8ParamLessZero = function (param) {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields[param]) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields[param]))){
				return false;
			}
			if (typeof ($scope.form_8_fields[param]) !== 'undefined' && (parseFloat($scope.form_8_fields[param]) < 0)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8pmaxmaziau10kwhzValid = function () {
		if (parseInt($scope.form_id) === 8 && $scope.form8Page5FieldRequired2()) {
			if (typeof ($scope.form_8_fields.pmax_maziau_10kw_hz) !== 'undefined' && (parseFloat($scope.form_8_fields.pmax_maziau_10kw_hz) < 50.2 || parseFloat($scope.form_8_fields.pmax_maziau_10kw_hz) > 50.5)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8pmaxmaziau10kwtValid = function () {
		if (parseInt($scope.form_id) === 8 && $scope.form8Page5FieldRequired2()) {
			if(typeof ($scope.form_8_fields.pmax_maziau_10kw_t) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.pmax_maziau_10kw_t))){
				return false;
			}

			if (typeof ($scope.form_8_fields.pmax_maziau_10kw_t) !== 'undefined' && parseFloat($scope.form_8_fields.pmax_maziau_10kw_t) < 0) {
				return false;
			}
		}
		return true;
	};

	$scope.form8pmax_daugiau_10kw_hzValid = function () {
		if (parseInt($scope.form_id) === 8 && $scope.form8Page5FieldRequired3()) {
			if(typeof ($scope.form_8_fields.pmax_daugiau_10kw_hz) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.pmax_daugiau_10kw_hz))){
				return false;
			}

			if (typeof ($scope.form_8_fields.pmax_daugiau_10kw_hz) !== 'undefined' && (parseFloat($scope.form_8_fields.pmax_daugiau_10kw_hz) < 51 || parseFloat($scope.form_8_fields.pmax_daugiau_10kw_hz) > 51.49)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8pmax_daugiau_10kw_tValid = function () {
		if (parseInt($scope.form_id) === 8 && $scope.form8Page5FieldRequired3()) {
			if(typeof ($scope.form_8_fields.pmax_daugiau_10kw_t) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.pmax_daugiau_10kw_t))){
				return false;
			}

			if (typeof ($scope.form_8_fields.pmax_daugiau_10kw_t) !== 'undefined' && parseFloat($scope.form_8_fields.pmax_daugiau_10kw_t) < 1800) {
				return false;
			}
		}
		return true;
	};

	$scope.form8pmax_2f_daugiau_10kw_hzValid = function () {
		if (parseInt($scope.form_id) === 8 && $scope.form8Page5FieldRequired3()) {
			if(typeof ($scope.form_8_fields.pmax_2f_daugiau_10kw_hz) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.pmax_2f_daugiau_10kw_hz))){
				return false;
			}

			if (typeof ($scope.form_8_fields.pmax_2f_daugiau_10kw_hz) !== 'undefined' && parseFloat($scope.form_8_fields.pmax_2f_daugiau_10kw_hz) < 51.5) {
				return false;
			}
		}
		return true;
	};

//------
	$scope.form8daznis_1f_hzValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.daznis_1f_hz) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.daznis_1f_hz))){
				return false;
			}

			if (typeof ($scope.form_8_fields.daznis_1f_hz) !== 'undefined' && (parseFloat($scope.form_8_fields.daznis_1f_hz) < 47.5 || parseFloat($scope.form_8_fields.daznis_1f_hz) > 49)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8daznis_1f_tValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.daznis_1f_t) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.daznis_1f_t))){
				return false;
			}

			if (typeof ($scope.form_8_fields.daznis_1f_t) !== 'undefined' && parseFloat($scope.form_8_fields.daznis_1f_t) < 1800) {
				return false;
			}
		}
		return true;
	};

	$scope.form8daznis_2f_hzValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.daznis_2f_hz) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.daznis_2f_hz))){
				return false;
			}

			if (typeof ($scope.form_8_fields.daznis_2f_hz) !== 'undefined' && parseFloat($scope.form_8_fields.daznis_2f_hz) > 47.49) {
				return false;
			}
		}
		return true;
	};

	$scope.form8apsauga_nuo_daznio_kitimo_spartosValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if (typeof ($scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos) !== 'undefined') {
				$scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos = $scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos.replace(/,/, '.');
				if ($scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos.toLowerCase() === 'nepalaikoma') {
					return true;
				}
			}
			if (typeof ($scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos) !== 'undefined' && parseFloat($scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos) >= 2.5) {
				return true;
			}
			return false;
		}
		return true;
	};

	$scope.form8auto_prijungimas_po_atistatymoValid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.auto_prijungimas_po_atistatymo) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.auto_prijungimas_po_atistatymo))){
				return false;
			}

			if (typeof ($scope.form_8_fields.auto_prijungimas_po_atistatymo) !== 'undefined' && parseFloat($scope.form_8_fields.auto_prijungimas_po_atistatymo) > 10) {
				return false;
			}
		}
		return true;
	};

	$scope.form8itampa_x_1Valid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.itampa_x_1) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.itampa_x_1))){
				return false;
			}
			if (typeof ($scope.form_8_fields.itampa_x_1) !== 'undefined' && (parseFloat($scope.form_8_fields.itampa_x_1) < 0.91 || parseFloat($scope.form_8_fields.itampa_x_1) > 0.92)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8itampa_x_2Valid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.itampa_x_2) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.itampa_x_2))){
				return false;
			}
			if (typeof ($scope.form_8_fields.itampa_x_2) !== 'undefined' && (parseFloat($scope.form_8_fields.itampa_x_2) < 0.95 || parseFloat($scope.form_8_fields.itampa_x_2) > 0.96)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8itampa_x_3Valid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.itampa_x_3) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.itampa_x_3))){
				return false;
			}
			if (typeof ($scope.form_8_fields.itampa_x_3) !== 'undefined' && (parseFloat($scope.form_8_fields.itampa_x_3) < 1.04 || parseFloat($scope.form_8_fields.itampa_x_3) > 1.05)) {
				return false;
			}
		}
		return true;
	};

	$scope.form8itampa_x_4Valid = function () {
		if (parseInt($scope.form_id) === 8) {
			if(typeof ($scope.form_8_fields.itampa_x_4) !== 'undefined' && isNaN(parseFloat($scope.form_8_fields.itampa_x_4))){
				return false;
			}
			if (typeof ($scope.form_8_fields.itampa_x_4) !== 'undefined' && (parseFloat($scope.form_8_fields.itampa_x_4) < 1.08 || parseFloat($scope.form_8_fields.itampa_x_4) > 1.09)) {
				return false;
			}
		}
		return true;
	};

	$scope.resetForm8Page5Fields = function() {
		$scope.form_8_fields.per_auksta_itampa_1u = '';
		$scope.form_8_fields.per_zema_itampa_2u = '';
		$scope.form_8_fields.pmax_maziau_10kw_hz = '';
		$scope.form_8_fields.pmax_maziau_10kw_t = '';
		$scope.form_8_fields.pmax_daugiau_10kw_hz = '';
		$scope.form_8_fields.pmax_daugiau_10kw_t = '';
		$scope.form_8_fields.pmax_2f_daugiau_10kw_hz = '';
		$scope.form_8_fields.daznis_1f_hz = '';
		$scope.form_8_fields.daznis_1f_t = '';
		$scope.form_8_fields.daznis_2f_hz = '';
		$scope.form_8_fields.apsauga_nuo_daznio_kitimo_spartos = '';
		$scope.form_8_fields.auto_prijungimas_po_atistatymo = '';
		$scope.form_8_fields.itampa_x_1 = '';
		$scope.form_8_fields.itampa_x_2 = '';
		$scope.form_8_fields.itampa_x_3 = '';
		$scope.form_8_fields.itampa_x_4 = '';
	};


	$scope.$watch('displayStatus', function(newVal) {
		if (!newVal) return;
		const showGAS = (
			$scope.form_id == 8 &&
			parseFloat($scope.form_8_fields.pmax_kw) > 100 &&
			parseFloat($scope.form_8_fields.obj_total_power) > 0.05 * parseFloat($scope.form_8_fields.pmax_kw)
		);
		if (newVal == 803 && !showGAS && $scope.form_8_fields.obj_gas_kiekis != '') {
			$scope.form_8_fields.obj_gas_kiekis = '';
		}
		if(parseFloat($scope.form_8_fields.pmax_kw) > 100){
			$scope.resetForm8Page5Fields();
		}
		else{
			$scope.form_8_fields.obj_scheme_number = '';
		}
//		if(newVal == 803 && ($scope.form_id != 8 || parseFloat($scope.form_8_fields.obj_sumine_irengtoji_galia) < 31) && $scope.form_8_fields.obj_gas_kiekis != ''){
//			$scope.form_8_fields.obj_gas_kiekis = '';
//		}
	});

}]).directive('formSubmit', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.form = angular.element(element);
		}
	};
})
.directive('formSubmitPeta', function () {
	return {
		restrict: 'A',
		link: function (scope, element, attr) {
			scope.formPeta = angular.element(element);
		}
	};
});;

EwSiteApp.controller('SignedFiles',['$scope', '$filter', '$log', '$http', function($scope, $filter, $log, $http){
	$scope.errors = [];
	$scope.hasError = false;
	$scope.max_file_size = 0;
	$scope.max_total_size = 0;
	// failai, priimti per ta pati batch'a, bet dar neidieti i flow.files
	$scope.pending_count = 0;
	$scope.pending_size = 0;
	$scope.closeAlert = function (index) {
		$scope.errors.splice(index, 1);
	};

	$scope.$on('cancelFiles', function () {
		if ($scope.flow) $scope.flow.cancel();
		$scope.uploaded_files = [];
	});

	$scope.transmitToParent = function(val){
		if (typeof ($scope.$parent.signed_files) !== 'undefined') {
			$scope.$parent.signed_files[val] = val;
		}
	};

	$scope.removeFromParent = function(fileId){
		if (typeof ($scope.$parent.signed_files) !== 'undefined') {
			delete $scope.$parent.signed_files[fileId];
		}
	};

	$scope.onFileAdded = function ($file, extensions) {
		var output = false;
		if($scope.max_files > 0 && $scope.flow && ($scope.flow.files.length + $scope.pending_count) >= $scope.max_files){
			$scope.hasError = true;
			$scope.errors.push($file.name+' - '+$scope.error_msg_max_files);
			return output;
		}
		if($scope.max_file_size>0 && $file.size>$scope.max_file_size){
			$scope.hasError = true;
			$scope.errors.push($file.name+' - '+$scope.error_msg_file_size);
			return output;
		}
		if($scope.max_total_size>0 && $scope.flow){
			var total_size = $file.size + $scope.pending_size;
			angular.forEach($scope.flow.files, function(f){
				total_size += f.size;
			});
			if(total_size > $scope.max_total_size){
				$scope.hasError = true;
				$scope.errors.push($file.name+' - '+$scope.error_msg_total_size);
				return output;
			}
		}
		if (typeof(extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1){
			output = true;
		}
		if (!output){
			$scope.hasError = true;
			$scope.errors.push($file.name+' '+$scope.error_msg);
		}
		else{
			$scope.pending_count++;
			$scope.pending_size += $file.size;
		}
		return output;
	};

	$scope.onFilesSubmitted = function ($flow) {
		$scope.pending_count = 0;
		$scope.pending_size = 0;
		$flow.upload();
	};

	function flowErrors ($file){
		if(typeof ($file.response) !== 'undefined'){
			if(typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId>0 && $file.response.success){
				return true;
			}
			else if(typeof ($file.response.message) !== 'undefined'){
				$scope.hasError = true;
				$scope.errors.push($file.name+' - '+$file.response.message);
				return false;
			}
		}
		else{
			$scope.hasError = true;
			$scope.errors.push($file.name+' - Server error');
			return false;
		}
		return null;
	}

	$scope.onFileSuccess = function ($file, $message, flowFile) {
		let flow_errors = flowErrors($file);
		if(true === flow_errors){
			$scope.transmitToParent($file.response.fileId);
		}
		else if(false === flow_errors){
			flowFile.cancel();
		}
	};

	$scope.onFileError = function ($file, $message, flowFile ) {
		if(false === flowErrors($file)){
			flowFile.cancel();
		}
	};


	$scope.removeUploaded = function(file){
		if (file.response && file.response.fileId) {
			$scope.removeFromParent(file.response.fileId);
		}
		file.cancel();
	};

}]);


EwSiteApp.controller('MultiUploadHelpdesk',['$scope', '$filter', '$log', '$attrs', function ($scope, $filter, $log, $attrs) {
	$scope.uploaded_files = [];
	$scope.errors = [];
	$scope.hasError = false;
	$scope.closeAlert = function (index) {
		$scope.errors.splice(index, 1);
	};

	$scope.$on('cancelFiles', function () {
		if ($scope.flow) $scope.flow.cancel();
		$scope.uploaded_files = [];
	});

	$scope.transmitToParent = function () {
		$scope.$parent.uploads_count += 1;
	};

	$scope.onFileAdded = function ($file, extensions) {
		var output = false;
		if (typeof (extensions[$file.getExtension()]) !== "undefined" && extensions[$file.getExtension()] == 1) {
			output = true;
		}
		if (!output) {
			$scope.hasError = true;
			$scope.errors.push($file.name + ' ' + $attrs.errorMsg);
		}
		return output;
	};

	function flowErrors($file) {
		if (typeof ($file.response) !== 'undefined') {
			if (typeof ($file.response.fileId) !== 'undefined' && $file.response.fileId > 0 && $file.response.success) {
				return true;
			} else if (typeof ($file.response.message) !== 'undefined') {
				$scope.hasError = true;
				$scope.errors.push($file.name + ' - ' + $file.response.message);
				return false;
			}
		} else {
			$scope.hasError = true;
			$scope.errors.push($file.name + ' - Server error');
			return false;
		}
		return null;
	}

	$scope.onFileSuccess = function ($file, $message, flowFile) {
		let flow_errors = flowErrors($file);
		if (true === flow_errors) {
			if($file.response.fileId){
				$scope.transmitToParent();
				$scope.$parent.uploaded_files.push({id: $file.response.fileId});
			}
		} else if (false === flow_errors) {
			flowFile.cancel();
		}
	};

	$scope.onFileError = function ($file, $message, flowFile) {
		if (false === flowErrors($file)) {
			flowFile.cancel();
		}
	};

	$scope.removeufile = function (ufile) {
		$scope.uploaded_files = $filter('filter')($scope.uploaded_files, {id: '!' + ufile.id}, true);
		if ($scope.$parent.uploads_count > 0) {
			$scope.$parent.uploads_count -= 1;
		}
	};


	$scope.removeUploaded = function (file) {
		file.cancel();
		if ($scope.$parent.uploads_count > 0) {
			$scope.$parent.uploads_count -= 1;
			$scope.$parent.uploaded_files = $filter('filter')($scope.uploaded_files, {id: '!' + file.response.fileId}, false);
		}
	};
}]);

//EwSiteApp.directive('numbersOnly', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/[^0-9]/g, '');
//				}
//			});
//		}
//	};
//});

//EwSiteApp.directive('floatNumbers', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/,/, '.').replace(/[^0-9\.]/g, '');
//				}
//			});
//		}
//	};
//});

//EwSiteApp.directive('floatNumbersNegative', function () {
//	return {
//		restrict: 'A',
//		scope: {
//			value: '=ngModel'
//		},
//		controller: function ($scope) {
//			$scope.$watch(function () {
//				return $scope.value;
//			}, function (newVal) {
//				if (typeof newVal !== 'undefined') {
//					$scope.value = newVal.replace(/,/, '.').replace(/[^0-9\.\-]/g, '');
////					$scope.value = newVal.replace('/,/', '.').replace(/[^-?\d.]/g, '');
//
//				}
//			});
//		}
//	};
//});
//
//EwSiteApp.directive('floatNumbersLimit', function () {
//    return {
//        restrict: 'A',
//        scope: {
//            value: '=ngModel'
//        },
//        controller: function ($scope) {
//            $scope.$watch(function () {
//                return $scope.value;
//            }, function (newVal) {
//                if (typeof newVal !== 'undefined') {
//                    newVal = newVal.replace(/,/, '.');
//                    newVal = newVal.replace(/[^0-9\.]/g, '');
//                    var decimalIndex = newVal.indexOf('.');
//                    if (decimalIndex !== -1) {
//                        var decimalPart = newVal.substr(decimalIndex + 1);
//                        if (decimalPart.length > 3) {
//                            decimalPart = decimalPart.substr(0, 3);
//                            newVal = newVal.substr(0, decimalIndex + 1) + decimalPart;
//                        }
//                    }
//
//                    $scope.value = newVal;
//                }
//            });
//        }
//    };
//});

EwSiteApp.controller('HelpdeskPreviewCtrl',['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
	$scope.item = angular.copy(item);
	$scope.save = function () {
		$uibModalInstance.close($scope.item);
	};
	$scope.cancel = function () {
		for (var i in $scope.require) {
			$scope.require[i] = false;
		}
		$uibModalInstance.dismiss();
	};
}]);

EwSiteApp.controller('HelpdeskForm8ConfirmCtrl',['$scope', '$uibModalInstance', 'item', function ($scope, $uibModalInstance, item) {
	$scope.item = angular.copy(item);
	$scope.confirm = function () {
		$uibModalInstance.close({state:1});
	};

	$scope.reject = function () {
		$uibModalInstance.close({state:2});
	};

	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};
}]);

function addContractorAddress() {
	$('#ContractorAddress').val('');
//	$('#ContractorAddress').parent().find("input.address_text").val('');
//	$('#ContractorAddress').parent().find("input.address_id").val('');
	$('#ContractorAddressNotFound').hide();
	$('#ContractorAddressSuggestions').hide();
	if ($('#addContractorAddressContainer').hasClass('vis_hidden')) {
		$('#addContractorAddressContainer').removeClass('vis_hidden');
	}
	$('#ContractorAddress_house').prop('required', false);
	$('#addContractorAddressContainer').show();
}

function addObjAddress() {
	$('#ObjAddress').val('');
//	$('#ObjAddress').parent().find("input.address_id").val('');
//	$('#ObjAddress').parent().find("input.address_text").val('');
	$('#obj_address_id').val('');
	$('#ObjAddressNotFound').hide();
	$('#ObjAddressSuggestions').hide();
	if ($('#addObjAddressContainer').hasClass('vis_hidden')) {
		$('#addObjAddressContainer').removeClass('vis_hidden');
	}
	$('#ObjAddress_house').prop('required', false);
	$('#addObjAddressContainer').show();
}


//EwSiteApp.directive('datepicker1', function () {
//	return {
//		restrict: 'A',
//		link: function (scope, element, attr) {
//			$(element).pikaday({
//				firstDay: 1,
//				format: 'YYYY-MM-DD',
////				defaultDate: (attr.value)?attr.value: new Date(),
//				setDefaultDate: true,
//				showDaysInNextAndPreviousMonths: true,
//				i18n: {
//					previousMonth: 'Praėjęs mėnesis',
//					nextMonth: 'Sekantis mėnesis',
//					months: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
//					weekdays: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
//					weekdaysShort: ['S', 'P', 'A', 'T', 'K', 'P', 'Š']
//				}
//			});
//			$(element).addClass('datepicker');
//		}
//	};
//});

//EwSiteApp.directive('onlyLettersInput', function () {
//	return {
//		require: 'ngModel',
//		link: function (scope, element, attr, ngModelCtrl) {
//			function fromUser(text) {
//				var transformedInput = text.replace(/[^a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0430-\u044f ]/g, '');
//				if (transformedInput !== text) {
//					ngModelCtrl.$setViewValue(transformedInput);
//					ngModelCtrl.$render();
//				}
//				return transformedInput;
//			}
//			ngModelCtrl.$parsers.push(fromUser);
//		}
//	};
//});
EwSiteApp.controller('HelpdeskSignFormCtrl',['$scope', '$http', '$filter', '$uibModal', '$log', '$sce', '$interval', '$timeout', function ($scope, $http, $filter, $uibModal, $log, $sce, $interval, $timeout) {

	$scope.submitted = false;
	$scope.displayStatus = 0;;
	$scope.dokobitSignUrl = jsHelpdesk.signUrl;
	$scope.documentUrl = jsHelpdesk.documentUrl;
	$scope.dataUrl = jsHelpdesk.data_url;
//	$scope.signConfirmUrl = jsHelpdesk.sign_confirm_url;
	$scope.signRejectUrl = jsHelpdesk.sign_reject_url;
	$scope.check_data = {};
	$scope.dokobit_state = 0;
	$scope.refreshInterval = 8000;
	$scope.token = '';
	$scope.nr = '';
	$scope.pin = '';
	$scope.iframe_height = '1000px';
	$scope.signing_origin = jsHelpdesk.signing_origin;
	$scope.dokobitFileId = '';
	$scope.file_url = '';
	$scope.action = '2';
	$scope.fileName = '';
	$scope.downloadUrl = '';
	$scope.choiseSubmitted = false;
	$scope.reject_note = '';
	var interval;

	$scope.goBackToDisplayStatus = function (status) {
		// Scroll to the <main> element
		var element = document.querySelector('main');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
		$scope.displayStatus = status;
	};

	$scope.getDocument = function() {
		$scope.errors = '';
		$scope.show_loader = true;
		$scope.iframe_src = '';
		if ($scope.documentUrl !== '') {
			$http({
				method: 'POST',
				url: $scope.documentUrl,
				data: {
					nr: $scope.nr,
					pin: $scope.pin
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {
				if (response.data.success) {
					$scope.displayStatus = 1;
					$scope.fileName = response.data.data.file_name;
					$scope.downloadUrl = response.data.data.file_download_url;
				} else if (angular.isDefined(response.data.message)) {
					$scope.errors = response.data.message;
				} else {
					$scope.errors = jsHelpdesk.server_blocked_text;
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}).then(function () {
				$scope.show_loader = false;

			});
		}
	};

	$scope.submitChoise = function(e) {
		e.preventDefault();
		if($scope.action == '1'){
			$scope.rejectSign();
		}
		if($scope.action == '2'){
			$scope.signFile();
		}
	};

	$scope.refreshList = function () {
		interval = $interval(function () {
			$scope.loadData();
		}, $scope.refreshInterval);
	};

	$scope.loadData = function () {
		if ($scope.dataUrl !== '') {
			$http({
				method: 'GET',
				url: $scope.dataUrl,
				params: {
					token: $scope.token
				}

			}).then(function (response) {
				$scope.dokobit_state = response.data.state;
				$scope.iframe_src = $sce.trustAsResourceUrl(response.data.iframe_src);
				if($scope.dokobit_state>2){
					$interval.cancel(interval);
				}
				if ($scope.dokobit_state === 3) {
					$scope.dokobitFileId = response.data.file_id;
					$scope.file_url = response.data.file_url;
				}
				if($scope.dokobit_state===4){
					window.location.reload();
				}
			});

		}
	};

	$scope.signFile = function() {
		$scope.errors = '';
		$scope.displayStatus = 2;
		$scope.show_loader = true;
		$scope.iframe_src = '';
		if ($scope.dokobitSignUrl !== '') {
			$http({
				method: 'POST',
				url: $scope.dokobitSignUrl,
				data: {
					nr: $scope.nr,
					pin: $scope.pin,
					name: $scope.signer_name,
					lastname: $scope.lastname,
				},
				xsrfCookieName: secure_xsrf_name,
				xsrfHeaderName: 'X-' + secure_xsrf_name
			}).then(function (response) {

				if (response.data.success) {
					$scope.show_loader = false;
					$scope.iframe_src = $sce.trustAsResourceUrl(response.data.iframe_src);
					$scope.token = response.data.token;
					$scope.refreshList();
				} else if (angular.isDefined(response.data.message)) {
					$scope.errors = response.data.message;
				} else {
					$scope.errors = jsHelpdesk.server_blocked_text;
				}
				if (angular.isDefined(response.data.debug)) {
					$log.debug(response.data.debug);
				}
			}).then(function () {
				$scope.show_loader = false;

			});
		}
	};

	$scope.rejectSign = function () {
		var template = 'helpdesk/owner_sign_reject_modal.html';
		var modalInstance = $uibModal.open({
			templateUrl: template,
			controller: 'HelpdeskSignRejectCtrl'
			//size: 'sm',

		});
		modalInstance.result.then(function(result){
			$scope.choiseSubmitted = true;
			$scope.errors = '';
			if ($scope.signRejectUrl !== '') {
				$http({
					method: 'POST',
					url: $scope.signRejectUrl,
					data: {
						nr: $scope.nr,
						pin: $scope.pin,
						reject_note: $scope.reject_note
					},
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {

					if (response.data.success) {
						window.location.reload();
					} else if (angular.isDefined(response.data.message)) {
						$scope.errors = response.data.message;
					} else {
						$scope.errors = jsHelpdesk.server_blocked_text;
					}
					if (angular.isDefined(response.data.debug)) {
						$log.debug(response.data.debug);
					}
				}).then(function () {
					$scope.show_loader = false;

				});
			}

		}, function(result){
			console.log(result);
		});
	};

//	$scope.confirmSign = function () {
//		$scope.choiseSubmitted = true;
//		$scope.errors = '';
//		if ($scope.signConfirmUrl !== '') {
//			$http({
//				method: 'POST',
//				url: $scope.signConfirmUrl,
//				data: {
//					nr: $scope.nr,
//					pin: $scope.pin,
//					fileuid: $scope.dokobitFileId
//				},
//				xsrfCookieName: secure_xsrf_name,
//				xsrfHeaderName: 'X-' + secure_xsrf_name
//			}).then(function (response) {
//				if (response.data.success) {
//					window.location.reload();
//				} else if (angular.isDefined(response.data.message)) {
//					$scope.errors = response.data.message;
//				} else {
//					$scope.errors = jsHelpdesk.server_blocked_text;
//				}
//				if (angular.isDefined(response.data.debug)) {
//					$log.debug(response.data.debug);
//				}
//			}).then(function () {
//				$scope.show_loader = false;
//
//			});
//		}
//	};

	function receiveMessage(event) {
		if (event.origin.startsWith($scope.signing_origin)) {
			if (event.data.success == true) {
				$scope.iframe_height = '200px';
				$scope.dokobit_state = 2;
				$timeout(function () {
					$scope.$apply();
				});
			}
		} else {
			return;
		}
	}
	window.addEventListener("message", receiveMessage, false);

}]);

EwSiteApp.controller('HelpdeskSignRejectCtrl',['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
	$scope.confirm = function () {
		$uibModalInstance.close();
	};

	$scope.cancel = function () {
		$uibModalInstance.dismiss();
	};
}]);
